import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage } from 'react-intl';
import { fromJS, is } from 'immutable';
import validator from 'validator';
import { uniqueId } from 'lodash';
import ReactResizeDetector from 'react-resize-detector';
import * as _ from 'lodash';
import moment from 'moment';
import injectReducer from 'utils/injectReducer';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import { makeSelectChangesToYourJourneyStep, makeSelectChangesToYourJourneyStepErrors } from './selectors';
import reducer from './reducer';
import messages from './messages';
import { makeSelectInsuredsList, makeSelectIsClaimForFieldEnabled } from '../../App/selectors';
import { Button } from '../components/Button';
import PageSectionHeader from '../components/PageSectionHeader';
import FlexBox from '../../../components/FlexBox';
import FNOLTooltip from '../../../components/FNOLTooltip';
import Section from '../components/Section';
import ControlContainer from '../components/ControlContainer';
import { TripCancellationVersion15AndAbove } from './components/TripCancellationVersion15AndAbove';
import { TripInterruptionVersion15AndAbove } from './components/TripInterruptionVersion15AndAbove';
import {
  ValidateGroup,
  Validate,
  ErrorMessage,
} from '../../../components/Validation';
import {
  saveFormData,
  handleFormDataChange,
  nextSlide,
  resetFormData,
  resetFormTravelInterruption,
  getFlightStatusRequest,
  resetFormFields,
} from './actions';
import {
  emailMedicalTravelDocument,
  emailInterruptionDocument,
} from '../../FastCover/actions';
import DatePicker from '../components/DatePicker/index';
import FlightDatePicker from '../components/FlightDatePicker/index';
import Textbox from '../components/Textbox';
import TextArea from '../components/TextArea';
import OptionsContainer from '../components/OptionsContainer';
import { CLAIMING_FOR } from './constants';
import { AdditionalList } from './components/Additional';
import { AdditionalListTripInterruption } from './components/AdditionalTripInterruption';
import { makeSelectCurrentStep } from '../../Wizard/selectors';
import AsyncButton from '../../../components/AsyncButton/index';
import AsyncButtonSendMail from '../../../components/AsyncButtonSendMail/index';
import { makeSelectProgressBarStatus } from '../../ProgressBar/selectors';
import HelpText from '../../../components/HelpText';
import TimePickerInput from '../../../components/TimePickerInput';
import { stepChangesToYourJourneyTrawickLookup } from '../../FastCover/dataMapper/claimCodeMapper';
import { required, checkDateOnly, checkFlightDateOnly, checkFlightNumberOnly } from '../../../utils/validation/validator';
import { InsuredList } from './components/AddInsured';
import { TravelSupplierList } from './components/AddTravelSupplier';
import { makeSelectJSONVersion, makeSelectIsClaimGroupAllowed } from '../../App/selectors';
import Select from 'react-select';

export class ChangesToYourJourneyStep extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validationCounter: 0,
      errors: [],
      physicianEmail: false,
    };
    this.validatorGroup = new ValidateGroup();
    this.handleNext = this.handleNext.bind(this);
    this.checkFormError = this.checkFormError.bind(this);
    this.onResize = this.onResize.bind(this);

    this.saveButtonId = uniqueId();
    this.emailMeDocumentButton = _.uniqueId();
    this.clickedItemId = '';
    this.nextButton = null;
  }

  componentWillReceiveProps(nextProps) {
    const { currentStep, step, stepName } = this.props;
    if ((stepName && nextProps.validateStep === stepName) || (currentStep !== nextProps.currentStep && currentStep === step)) {
      this.checkFormError();
    }

    if (this.props.isReadOnly && nextProps.errors !== this.props.errors) {
      this.state.validationCounter += 1;
      this.validatorGroup.checkValidation();
    }

    if (!nextProps.loading) {
      this.clickedItemId = '';
    }
  }

  onChange = (propertyName) => (event) => {
    if (event === null) {
      this.props.onFormDataChange(propertyName, null);
      return;
    }

    if (event.constructor.name === 'Moment') {
      this.props.onFormDataChange(propertyName, removeTimeZoneFromDate(event.toDate().toString()));
    } else {
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      if (target.type === 'radio') {
        this.props.adjust();
      }
      this.props.onFormDataChange(propertyName, value);
    }
    // this.props.makeDirty(6);
  };

  // Trip Interruption
  onInsuredTripInterruptionChange = (data) => {
    this.props.onFormDataChange('form.insuredsForInterruption', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onTripInterruptionChange = (data) => {
    this.props.onFormDataChange('form.lossInformationItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onSupplierTripInterruption = (data) => {
    this.props.onFormDataChange('form.travelSuppliersTravelInterruption', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  // Travel Cancellation
  onTravelCancellationItemsChange = (data) => {
    this.props.onFormDataChange('form.lossInformationItemsTravelCancellation', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onInsuredTravelCancellationChange = (data) => {
    this.props.onFormDataChange('form.insuredsTravelCancellation', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  // Trip Cancellation For Any Reason
  onTripCancellationForAnyReasonChange = (data) => {
    this.props.onFormDataChange('form.lossInformationItemsTripCancellationForAnyReason', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onInsuredTripCancellationForAnyReasonChange = (data) => {
    this.props.onFormDataChange('form.insuredsTripCancellationForAnyReason', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onSupplierTripCancellationForAnyReasonChange = (data) => {
    this.props.onFormDataChange('form.travelSuppliersTripCancellationForAnyReason', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  // Travel delay
  onDelayInformationItemsChange = (data) => {
    this.props.onFormDataChange('form.delayInformationItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onMissedConnectionInformationItemsChange = (data) => {
    this.props.onFormDataChange('form.missedConnectionInformationItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onResize = () => {
    const { adjust } = this.props;
    if (adjust) {
      adjust();
    }
  };

  getSelectedClaiming = () => {
    const {
      claimForPassportCreditCard,
      claimForTheftOfCash,
      claimForLuggageAndPersonalEffect,
    } = this.props.form;

    let selectedValue = null;

    switch ('true') {
      case claimForPassportCreditCard:
        selectedValue = CLAIMING_FOR.PASSPORT_CREDIT_CARD;
        break;
      case claimForTheftOfCash:
        selectedValue = CLAIMING_FOR.THEFT_OF_CASH;
        break;
      case claimForLuggageAndPersonalEffect:
        selectedValue = CLAIMING_FOR.LUGGAGE_AND_PERSONAL_EFFECTS;
        break;
      default:
        selectedValue = null;
        break;
    }

    return selectedValue;
  };

  shouldDisable = (field) => {
    const selectedValue = this.getSelectedClaiming();

    return !!selectedValue && selectedValue !== field;
  };

  handleChangePhoneNumber = (propertyName) => (event) => {
    const target = event.target;
    const regex = /^[0-9-]+$/;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (regex.test(value) || value === '') {
      this.props.onFormDataChange(propertyName, value);
    }
  };

  handleChangeTypeOfTransport = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.props.onFormDataChange(propertyName, value);
  };

  appendIds = (array) =>
    array.map((item) => {
      let newItem = item; // eslint-disable-line
      if (!item.id) {
        newItem.id = new Date().getTime().toString();
      }
      return newItem;
    });

  validateTableField(groups) {
    const invalid = _.some(groups, (fields) =>
      _.some(fields, (value) => {
        const newValue = value ? value.toString() : '';
        return validator.isEmpty(newValue);
      })
    );
    return invalid;
  }

  handleKeyDown = (e) => {
    if (e.shiftKey && e.key === 'Tab') {
      return;
    }
    if (e.key === 'Tab') {
      e.preventDefault();
    }
  };

  handleSaveButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.props.onFormDataSave();
    this.nextButton.focus();
  };

  showSpinnerForElement = (elementId) => this.clickedItemId === elementId;

  checkFormError() {
    const {
      tripCancellation,
      tripCancellationForAnyReason,
      travelInterruption,
      travelDelay,
      missedConnection,
    } = this.props.form;
    const isSelectBenefit = tripCancellation === 'true' ||
      tripCancellationForAnyReason === 'true' ||
      travelInterruption === 'true' ||
      travelDelay === 'true' ||
      missedConnection === 'true';
    const valid = isSelectBenefit && this.validatorGroup.checkValidation();
    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }
  }

  handleChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (propertyName === 'form.tripCancellation') {
      this.props.resetFormFields([
        'reasonForTripCancellation',
        'nameOfEmployer',
        'whenWereYouNotified',
        'dateOfTerminationOrLayoff',
        'howLongWereYouEmployed',
        'wasThisWorkTransfer',
        'nameOfServiceCallingToActiveDuty',
        'dateYouBecame',
        'nameOfCourtOrAuthority',
        'dateToAppearInCourt',
        'nameOfAuthorityHandlingTheIncident',
        'dateOfIncident',
        'chooseAnInsured',
        'fullName',
        'relationshipToTraveler',
        'pleaseExplainWhyThisInjuryOrSicknessCausedTheTripToBeCancelled',
        'nameOfDepartmentOfTransportationOrLocalGovernmentSubstantiatingClosure',
        'dateOfTransportClosureIncident',
        'dateOfTrafficAccident',
        'nameOfTravelSupplier',
        'whenDidOperationsResume',
        'whatCausedTheServiceCessation',
        'whenWasThePrimaryResidenceOrDestinationDeemedUninhabitable',
        'whereWasUninhabitable',
        'provideDetailsOfTheIncident',
        'dateSicknessOrInjuryBegan',
        'dateTravelCancellation',
        'lossInformationItemsTravelCancellation',
      ]);
    } else if (propertyName === 'form.travelInterruption') {
      this.props.resetFormFields([
        'reasonForTripCancellation',
        'nameOfEmployer',
        'whenWereYouNotified',
        'dateOfTerminationOrLayoff',
        'howLongWereYouEmployed',
        'wasThisWorkTransfer',
        'nameOfServiceCallingToActiveDuty',
        'dateYouBecame',
        'nameOfCourtOrAuthority',
        'dateToAppearInCourt',
        'nameOfAuthorityHandlingTheIncident',
        'dateOfIncident',
        'chooseAnInsured',
        'fullName',
        'relationshipToTraveler',
        'pleaseExplainWhyThisInjuryOrSicknessCausedTheTripToBeCancelled',
        'nameOfDepartmentOfTransportationOrLocalGovernmentSubstantiatingClosure',
        'dateOfTransportClosureIncident',
        'dateOfTrafficAccident',
        'nameOfTravelSupplier',
        'whenDidOperationsResume',
        'whatCausedTheServiceCessation',
        'whenWasThePrimaryResidenceOrDestinationDeemedUninhabitable',
        'whereWasUninhabitable',
        'provideDetailsOfTheIncident',
        'dateSicknessOrInjuryBegan',
        'dateTripInterrupted',
        'lossInformationItems',
      ]);
    } else if (propertyName === 'form.missedConnection') {
      this.props.resetFormFields([
        'reasonsForMissedConnection',
        'missedConnectionInformationItems',
        'typeOfTransportMissedConnection',
        'flightNumberMissedConnection',
        'flightDateMissedConnection',
        'flightDetailsMissedConnection',
        'cruiseLineDetailsMissedConnection',
        'otherDetailsMissedConnection',
      ]);
    } else if (propertyName === 'form.travelDelay') {
      this.props.resetFormFields([
        'reasonsForDelay',
        'delayInformationItems',
        'typeOfTransportTravelDelay',
        'flightNumberTravelDelay',
        'flightDateTravelDelay',
        'flightDetailsTravelDelay',
        'cruiseLineDetailsTravelDelay',
        'otherDetailsTravelDelay',
      ]);
    } else if (propertyName === 'form.didYourInitialFlightDelayCauseAMissedConnection') {
      this.props.resetFormFields([
        'typeOfTransportMissedConnection',
        'flightNumberMissedConnection',
        'flightDateMissedConnection',
        'flightDetailsMissedConnection',
        'cruiseLineDetailsMissedConnection',
        'otherDetailsMissedConnection',
      ]);
    }
    this.props.onFormDataChange(propertyName, value);
  };

  handleNext = () => {
    const {
      tripCancellation,
      tripCancellationForAnyReason,
      travelInterruption,
      travelDelay,
      missedConnection,
    } = this.props.form;
    const isSelectBenefit = tripCancellation === 'true' ||
      tripCancellationForAnyReason === 'true' ||
      travelInterruption === 'true' ||
      travelDelay === 'true' ||
      missedConnection === 'true';
    const { submitted } = this.props;
    if (submitted) {
      this.props.next();
      return;
    }

    // const errors = this.validatorGroup.getErrors();
    const valid = isSelectBenefit && this.validatorGroup.checkValidation();

    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }

    this.props.onFormDataSave();
    this.props.next();
  };

  handleFormDataSave = () => {
    this.props.onFormDataSave();
  };

  handleDayChange = (propertyName) => (day) => {
    const dayWithoutTimeZone = removeTimeZoneFromDate(day);
    this.props.onFormDataChange(propertyName, dayWithoutTimeZone);
    // this.props.makeDirty(6);
  };

  flightVerificationTravelCancellation = (flightObjectName) => () => {
    const tripCancellationCode = stepChangesToYourJourneyTrawickLookup.tripCancellation.claimCode;
    const { flightNumber, flightDate } = this.props.form;
    const isFlightNumberValid = checkFlightNumberOnly(flightNumber);
    const isFlightDateValid = checkFlightDateOnly(flightDate);
    if (isFlightNumberValid && isFlightDateValid) {
      if (flightNumber && flightDate) {
        this.props.getFlightStatus(flightNumber, flightDate, flightObjectName, this.props.stepName, tripCancellationCode);
      }
    }
  };

  flightVerificationTravelInterruption = (flightObjectName) => () => {
    const { flightNumberTravelInterruption, flightDateTravelInterruption } = this.props.form;
    const isFlightNumberValid = checkFlightNumberOnly(flightNumberTravelInterruption);
    const isFlightDateValid = checkFlightDateOnly(flightDateTravelInterruption);
    if (isFlightNumberValid && isFlightDateValid) {
      if (flightNumberTravelInterruption && flightDateTravelInterruption) {
        this.props.getFlightStatus(flightNumberTravelInterruption, flightDateTravelInterruption, flightObjectName, this.props.stepName, '');
      }
    }
  };

  flightVerificationTravelDelay = (flightObjectName) => () => {
    const { flightNumberTravelDelay, flightDateTravelDelay } = this.props.form;
    const isFlightNumberValid = checkFlightNumberOnly(flightNumberTravelDelay);
    const isFlightDateValid = checkFlightDateOnly(flightDateTravelDelay);
    if (isFlightNumberValid && isFlightDateValid) {
      if (flightNumberTravelDelay && flightDateTravelDelay) {
        this.props.getFlightStatus(flightNumberTravelDelay, flightDateTravelDelay, flightObjectName, this.props.stepName, '');
      }
    }
  };

  flightVerificationMissedConnection = (flightObjectName) => () => {
    const { flightNumberMissedConnection, flightDateMissedConnection } = this.props.form;
    const isFlightNumberValid = checkFlightNumberOnly(flightNumberMissedConnection);
    const isFlightDateValid = checkFlightDateOnly(flightDateMissedConnection);
    if (isFlightNumberValid && isFlightDateValid) {
      if (flightNumberMissedConnection && flightDateMissedConnection) {
        this.props.getFlightStatus(flightNumberMissedConnection, flightDateMissedConnection, flightObjectName, this.props.stepName, '');
      }
    }
  };

  handleReasonsForDelay = (propertyName) => (event) => {
    const { reasonsForDelay } = this.props.form;
    const reasons = !!reasonsForDelay && typeof reasonsForDelay.toJS === 'function'
      ? reasonsForDelay.toJS()
      : reasonsForDelay || [];
    const listChecked = _.cloneDeep(reasons);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  handleReasonsForMissedConnection = (propertyName) => (event) => {
    const { reasonsForMissedConnection } = this.props.form;
    const reasons = !!reasonsForMissedConnection && typeof reasonsForMissedConnection.toJS === 'function'
      ? reasonsForMissedConnection.toJS()
      : reasonsForMissedConnection || [];
    const listChecked = _.cloneDeep(reasons);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  handleReasonsForTripInterruption = (propertyName) => (event) => {
    const { reasonsForTripInterruption } = this.props.form;
    const reasons = !!reasonsForTripInterruption && typeof reasonsForTripInterruption.toJS === 'function'
      ? reasonsForTripInterruption.toJS()
      : reasonsForTripInterruption || [];
    const listChecked = _.cloneDeep(reasons);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  handleFlightSelection = (propertyName, index) => {
    this.props.onFormDataChange(propertyName, index);
  };

  handleChangeFlightDetail = (flightObjectName, propertyName) => (eventOrDay) => {
    const { form } = this.props;
    const flights = form[flightObjectName].flights || [];

    // Determine the value based on whether it's a date picker event or regular input event
    const value = eventOrDay && eventOrDay.target ? eventOrDay.target.value : eventOrDay;

    if (flights.length === 1) {
      // Update first flight's property
      const updatedFlight = { ...flights[0], [propertyName]: value };
      const updatedFlights = [updatedFlight];
      this.props.onFormDataChange(`form.${flightObjectName}.flights`, updatedFlights);
    } else if (flights.length > 1 && form[flightObjectName].selectedFlightIndex !== null) {
      // Update selected flight's property
      const updatedFlights = flights.map((flight, index) => {
        if (index === form[flightObjectName].selectedFlightIndex) {
          return { ...flight, [propertyName]: value };
        }
        return flight;
      });
      this.props.onFormDataChange(`form.${flightObjectName}.flights`, updatedFlights);
    }
  };

  handleReasonsForTripCancellation = (propertyName) => (event) => {
    const { reasonForTripCancellation } = this.props.form;
    const reasons = !!reasonForTripCancellation && typeof reasonForTripCancellation.toJS === 'function'
      ? reasonForTripCancellation.toJS()
      : reasonForTripCancellation || [];
    const listChecked = _.cloneDeep(reasons);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  summaryFormValue() {
    return _.mapValues(this.props.form, (prop) => prop || 'N/A');
  }

  handleUncheckedFormState = (field, resetAction) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    if (value === 'false') {
      resetAction();
    }

    this.handleChange(field)(event);
  };

  handleEmailMeButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.props.sendPhysicianEmail();
  };

  handleEmailInterruption = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.props.sendPhysicianEmailInterruption();
  };

  // Trip Cancellation
  renderInsuredsTravelCancellation() {
    const { insuredsTravelCancellation } = this.props.form;
    const newInsureds = this.appendIds(insuredsTravelCancellation);
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <InsuredList
          data={newInsureds}
          onChange={this.onInsuredTravelCancellationChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
        />
      </div>
    );
  }

  renderTravelCancellationAdditionalItems() {
    const { lossInformationItemsTravelCancellation = [] } = this.props.form;
    const newLossInformationItems = this.appendIds(lossInformationItemsTravelCancellation);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newLossInformationItems}
          onChange={this.onTravelCancellationItemsChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  // Trip Cancellation For Any Reason
  renderForAnyReasonInformationItems() {
    const { lossInformationItemsTripCancellationForAnyReason = [] } = this.props.form;
    const newDelayInformationItems = this.appendIds(lossInformationItemsTripCancellationForAnyReason);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newDelayInformationItems}
          onChange={this.onTripCancellationForAnyReasonChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderInsuredsTripCancellationForAnyReason() {
    const { insuredsTripCancellationForAnyReason = [] } = this.props.form;
    const newInsureds = this.appendIds(insuredsTripCancellationForAnyReason);
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <InsuredList
          data={newInsureds}
          onChange={this.onInsuredTripCancellationForAnyReasonChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
        />
      </div>
    );
  }

  renderTravelSupplierTripCancellationForAnyReason() {
    const { travelSuppliersTripCancellationForAnyReason = [] } = this.props.form;
    const travelSuppliersTripCancellationForAnyReasons = !!travelSuppliersTripCancellationForAnyReason && typeof travelSuppliersTripCancellationForAnyReason.toJS === 'function'
      ? travelSuppliersTripCancellationForAnyReason.toJS()
      : travelSuppliersTripCancellationForAnyReason || [];
    const newSuppliers = this.appendIds(travelSuppliersTripCancellationForAnyReasons);
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <TravelSupplierList
          data={newSuppliers}
          onChange={this.onSupplierTripCancellationForAnyReasonChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
        />
      </div>
    );
  }

  // TripInterruption
  renderTravelInterruption() {
    const {
      travelInterruption,
      dateTripInterrupted,
      reasonForInterruption,
      nameOfPersonHavingSickness,
      dateOfBirth,
      relationshipToClaimant,
      dateSicknessOrInjuryBegan,
      dateEnded,
      natureOfSicknessOrInjury,
      fromDate,
      toDate,
      enableTimeInterruption,
      reasonsForTripInterruption,
      flightNumberTravelInterruption,
      flightDateTravelInterruption,
      flightDetailsTravelInterruption,
      typeOfTransportTravelInterruption,
      cruiseLineDetailsTravelInterruption,
      otherDetailsTravelInterruption,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted, jsonVersion, isClaimGroupAllowed } = this.props;
    const buttonEmailMeDisable = !!enableTimeInterruption && new Date().getTime() < enableTimeInterruption;
    const isReadOnly = submitted || isSummary;
    const reasonsForTripInterruptions = !!reasonsForTripInterruption && typeof reasonsForTripInterruption.toJS === 'function'
      ? reasonsForTripInterruption.toJS()
      : reasonsForTripInterruption || [];
    const newVersion = jsonVersion > 7;
    const isOnlyOne = reasonsForTripInterruptions.length > 0;
    const isReason2 = reasonsForTripInterruptions.includes('reasons2');
    const isReasons15 = reasonsForTripInterruptions.includes('reasons15');
    const isReasonWeatherRelated = reasonsForTripInterruptions.includes('reasons7');
    const isFlightNumberValid = checkFlightNumberOnly(flightNumberTravelInterruption);
    const isFlightDateValid = checkFlightDateOnly(flightDateTravelInterruption);
    const showSectionFlightDetails = flightDetailsTravelInterruption.onSuccessFlighAPIRequest || flightDetailsTravelInterruption.callFailFlighAPIRequest;
    const isDisable = isReadOnly || flightDetailsTravelInterruption.onSuccessFlighAPIRequest || !flightDetailsTravelInterruption.manuallyEnterFlight;

    return (
      travelInterruption === 'true' && (
        <div>
          <div className={'ml-3'}>
            <div className={'col-sm-12 form-group'}>
              <Validate
                name="reasonsForTripInterruption"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={reasonsForTripInterruptions}
                fieldName={messages.reasonsForTripInterruption}
              >
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={(isReadOnly || isOnlyOne) && !reasonsForTripInterruptions.includes('reasons1')}
                    type="checkbox"
                    name="reasons1"
                    checked={reasonsForTripInterruptions.includes('reasons1')}
                    onChange={this.handleReasonsForTripInterruption('form.reasonsForTripInterruption')}
                  />
                  <span>
                    <FormattedMessage {...messages.reasons1} />
                  </span>
                </div>
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={(isReadOnly || isOnlyOne) && !reasonsForTripInterruptions.includes('reasons2')}
                    type="checkbox"
                    name="reasons2"
                    checked={reasonsForTripInterruptions.includes('reasons2')}
                    onChange={this.handleReasonsForTripInterruption('form.reasonsForTripInterruption')}
                  />
                  <span>
                    <FormattedMessage {...messages.reasons2} />
                  </span>
                  {(isReason2 && newVersion) &&
                    <div>
                      <div className={'ml-2 row'}>
                        <div className={'col-sm-5 form-group'}>
                          <PageSectionHeader>
                            <FormattedMessage {...messages.nameOfPersonHavingSickness} />
                          </PageSectionHeader>
                          <Textbox
                            name="nameOfPersonHavingSickness"
                            type="text"
                            onChange={this.handleChange('form.nameOfPersonHavingSickness')}
                            value={nameOfPersonHavingSickness}
                            disabled={isReadOnly}
                          />
                        </div>
                        <div className={'col-sm-3 form-group'}>
                          <PageSectionHeader>
                            <FormattedMessage {...messages.dateOfBirth} />
                          </PageSectionHeader>
                          <DatePicker
                            position={'bottom-start'}
                            disabled={isReadOnly}
                            name="dateOfBirth"
                            type="text"
                            onDayChange={this.handleDayChange('form.dateOfBirth')}
                            value={dateOfBirth}
                          />
                        </div>
                        <div className={'col-sm-4 form-group'}>
                          <PageSectionHeader>
                            <FormattedMessage {...messages.relationshipToClaimant} />
                          </PageSectionHeader>
                          <Textbox
                            name="relationshipToClaimant"
                            type="text"
                            onChange={this.handleChange('form.relationshipToClaimant')}
                            value={relationshipToClaimant}
                            disabled={isReadOnly}
                          />
                        </div>
                      </div>
                      <div className={'ml-2 row'}>
                        <div className={'col-sm-4 form-group'}>
                          <PageSectionHeader>
                            <FormattedMessage {...messages.dateSicknessOrInjuryBegan} />
                          </PageSectionHeader>
                          <DatePicker
                            position={'bottom-start'}
                            disabled={isReadOnly}
                            name="dateSicknessOrInjuryBegan"
                            type="text"
                            onDayChange={this.handleDayChange('form.dateSicknessOrInjuryBegan')}
                            value={dateSicknessOrInjuryBegan}
                          />
                        </div>
                        <div className={'col-sm-4 form-group'}>
                          <PageSectionHeader>
                            <FormattedMessage {...messages.dateEnded} />
                          </PageSectionHeader>
                          <DatePicker
                            position={'bottom-start'}
                            disabled={isReadOnly}
                            name="dateEnded"
                            type="text"
                            onDayChange={this.handleDayChange('form.dateEnded')}
                            value={dateEnded}
                          />
                        </div>
                        <div className={'col-sm-4 form-group'}>
                        </div>
                      </div>
                      <div className={'ml-2 row'}>
                        <div className={'col-sm-12 form-group'}>
                          <PageSectionHeader>
                            <FormattedMessage {...messages.natureOfSicknessOrInjury} />
                          </PageSectionHeader>
                          <TextArea
                            disabled={isReadOnly}
                            name="natureOfSicknessOrInjury"
                            type="text"
                            onChange={this.handleChange('form.natureOfSicknessOrInjury')}
                            value={natureOfSicknessOrInjury}
                            isSummary={isSummary}
                          />
                        </div>
                      </div>
                      <div className={'ml-2 row'}>
                        <div className={'col-sm-12 form-group'}>
                          <PageSectionHeader>
                            <FormattedMessage {...messages.periodOfHospitalization} />
                          </PageSectionHeader>
                        </div>
                        <div className={'form-group col-sm-3'}>
                          <PageSectionHeader>
                            <FormattedMessage {...messages.fromDate} />
                          </PageSectionHeader>
                          <DatePicker
                            position={'bottom-start'}
                            disabled={isReadOnly}
                            name="fromDate"
                            type="text"
                            onDayChange={this.handleDayChange('form.fromDate')}
                            value={fromDate}
                          />
                        </div>
                        <div className={'form-group col-sm-3'}>
                          <PageSectionHeader>
                            <FormattedMessage {...messages.toDate} />
                          </PageSectionHeader>
                          <DatePicker
                            position={'bottom-start'}
                            disabled={isReadOnly}
                            name="toDate"
                            type="text"
                            onDayChange={this.handleDayChange('form.toDate')}
                            value={toDate}
                          />
                        </div>
                        <div className={'form-group col-sm-6'}>
                        </div>
                      </div>
                      <div className={'ml-2 row'}>
                        <div className={'form-group col-sm-7'}>
                          <HelpText>
                            On clicking the button an email with the Statement of Attending Physician will be sent to you. Once sent please check your email.
                          </HelpText>
                        </div>
                        <div className={'form-group col-sm-5'}>
                          <AsyncButtonSendMail
                            id={this.emailMeDocumentButton}
                            className={buttonEmailMeDisable ? 'btn-action-success' : 'btn-authentication'}
                            disabled={buttonEmailMeDisable || isReadOnly}
                            loading={this.props.loading}
                            spinner={this.showSpinnerForElement(this.emailMeDocumentButton)}
                            onClick={this.handleEmailInterruption}
                          >
                            Statement of Attending Physician
                          </AsyncButtonSendMail>
                        </div>
                      </div>
                    </div>
                  }
                </div>
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={(isReadOnly || isOnlyOne) && !reasonsForTripInterruptions.includes('reasons3')}
                    type="checkbox"
                    name="reasons3"
                    checked={reasonsForTripInterruptions.includes('reasons3')}
                    onChange={this.handleReasonsForTripInterruption('form.reasonsForTripInterruption')}
                  />
                  <span>
                    <FormattedMessage {...messages.reasons3} />
                  </span>
                </div>
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={(isReadOnly || isOnlyOne) && !reasonsForTripInterruptions.includes('reasons4')}
                    type="checkbox"
                    name="reasons4"
                    checked={reasonsForTripInterruptions.includes('reasons4')}
                    onChange={this.handleReasonsForTripInterruption('form.reasonsForTripInterruption')}
                  />
                  <span>
                    <FormattedMessage {...messages.reasons4} />
                  </span>
                </div>
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={(isReadOnly || isOnlyOne) && !reasonsForTripInterruptions.includes('reasons5')}
                    type="checkbox"
                    name="reasons5"
                    checked={reasonsForTripInterruptions.includes('reasons5')}
                    onChange={this.handleReasonsForTripInterruption('form.reasonsForTripInterruption')}
                  />
                  <span>
                    <FormattedMessage {...messages.reasons5} />
                  </span>
                </div>
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={(isReadOnly || isOnlyOne) && !reasonsForTripInterruptions.includes('reasons6')}
                    type="checkbox"
                    name="reasons6"
                    checked={reasonsForTripInterruptions.includes('reasons6')}
                    onChange={this.handleReasonsForTripInterruption('form.reasonsForTripInterruption')}
                  />
                  <span>
                    <FormattedMessage {...messages.reasons6} />
                  </span>
                </div>
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={(isReadOnly || isOnlyOne) && !reasonsForTripInterruptions.includes('reasons7')}
                    type="checkbox"
                    name="reasons7"
                    checked={reasonsForTripInterruptions.includes('reasons7')}
                    onChange={this.handleReasonsForTripInterruption('form.reasonsForTripInterruption')}
                  />
                  <span>
                    <FormattedMessage {...messages.reasons7} />
                  </span>
                  {isReasonWeatherRelated === true &&
                    <div>
                      <div className={'pt-2'} style={{ fontWeight: 'bold' }}>
                        <FormattedMessage {...messages.typeOfTransport} />
                      </div>
                      <div className={'ml-2 row pt-2'}>
                        <div className={'col-sm-12 form-group'}>
                          <FlexBox>
                            <OptionsContainer>
                              <input
                                disabled={isReadOnly}
                                type="radio"
                                value="airline"
                                checked={typeOfTransportTravelInterruption === 'airline'}
                                onChange={this.handleChangeTypeOfTransport('form.typeOfTransportTravelInterruption')}
                              />
                              <FormattedMessage {...messages.airline} />
                            </OptionsContainer>
                            <OptionsContainer>
                              <input
                                disabled={isReadOnly}
                                type="radio"
                                value="cruiseLine"
                                checked={typeOfTransportTravelInterruption === 'cruiseLine'}
                                onChange={this.handleChangeTypeOfTransport('form.typeOfTransportTravelInterruption')}
                              />
                              <FormattedMessage {...messages.cruiseLine} />
                            </OptionsContainer>
                            <OptionsContainer>
                              <input
                                disabled={isReadOnly}
                                type="radio"
                                value="other"
                                checked={typeOfTransportTravelInterruption === 'other'}
                                onChange={this.handleChangeTypeOfTransport('form.typeOfTransportTravelInterruption')}
                              />
                              <FormattedMessage {...messages.other} />
                            </OptionsContainer>
                          </FlexBox>
                        </div>
                      </div>
                      {typeOfTransportTravelInterruption === 'airline' &&
                        <div className={'ml-2'}>
                          <PageSectionHeader>
                            <FormattedMessage {...messages.pleaseEnterYourFlightNumberAndDateBelow} />
                          </PageSectionHeader>
                          <div className={'row'}>
                            <div className={'col-sm-4 form-group'}>
                              <Validate
                                name="flightNumber"
                                validators={[checkFlightNumberOnly, required]}
                                group={this.validatorGroup}
                                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                                validationCounter={this.state.validationCounter}
                                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                                defaultValue={flightNumberTravelInterruption}
                                fieldName={messages.flightNumber}
                              >
                                <Textbox
                                  name="flightNumber"
                                  type="text"
                                  onChange={this.handleChange('form.flightNumberTravelInterruption')}
                                  value={flightNumberTravelInterruption}
                                  disabled={isReadOnly}
                                />
                                <ErrorMessage for="required">
                                  <FormattedMessage
                                    {...messages.isRequired}
                                    values={messages.flightNumber}
                                  />
                                </ErrorMessage>
                                <ErrorMessage for="checkFlightNumberOnly">
                                  <FormattedMessage
                                    {...messages.checkFlightNumber}
                                    values={messages.flightNumber}
                                  />
                                </ErrorMessage>
                              </Validate>
                            </div>
                            <div className={'col-sm-4 form-group'}>
                              <Validate
                                name="flightDate"
                                validators={[checkFlightDateOnly, required]}
                                group={this.validatorGroup}
                                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                                validationCounter={this.state.validationCounter}
                                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                                defaultValue={flightDateTravelInterruption}
                                fieldName={messages.flightDate}
                              >
                                <FlightDatePicker
                                  position={'bottom-start'}
                                  disabled={isReadOnly}
                                  name="flightDate"
                                  type="text"
                                  onDayChange={this.handleDayChange('form.flightDateTravelInterruption')}
                                  value={flightDateTravelInterruption}
                                />
                                <ErrorMessage for="required">
                                  <FormattedMessage
                                    {...messages.isRequired}
                                    values={messages.flightDate}
                                  />
                                </ErrorMessage>
                                <ErrorMessage for="checkFlightDateOnly">
                                  <FormattedMessage
                                    {...messages.checkFlightDate}
                                    values={messages.flightDate}
                                  />
                                </ErrorMessage>
                              </Validate>
                            </div>
                            <div className={'col-sm-2 form-group'}></div>
                          </div>
                          <div className={'row'}>
                            <div className={'col-sm-12 form-group'}>
                              <AsyncButton
                                id="searchFlightButton"
                                className={'btn-authentication'}
                                disabled={isReadOnly || (!isFlightNumberValid && !isFlightDateValid)}
                                loading={this.props.loading}
                                spinner={this.showSpinnerForElement('searchFlightButton')}
                                onClick={this.flightVerificationTravelInterruption('flightDetailsTravelInterruption')}
                              >
                                Search Flight
                              </AsyncButton>
                            </div>
                          </div>
                          {flightDetailsTravelInterruption.onPendingFlighAPIRequest && (
                            <div className={'ml-2 row'}>
                              <div style={{ fontWeight: 'bold' }}>
                                <FormattedMessage {...messages.pendingFlightApiRequest} />
                              </div>
                            </div>
                          )}
                          {flightDetailsTravelInterruption.callFailFlighAPIRequest && flightDetailsTravelInterruption && flightDetailsTravelInterruption.error && (
                            <div className={'row'}>
                              <div className={'col-sm-12'} style={{ color: 'red' }}>
                                {flightDetailsTravelInterruption.error}
                              </div>
                            </div>
                          )}
                          {flightDetailsTravelInterruption.callFailFlighAPIRequest && flightDetailsTravelInterruption && flightDetailsTravelInterruption.error && (
                            <div className={'row'}>
                              <div className={'form-group col-md-6'}>
                                <OptionsContainer>
                                  <input
                                    disabled={isReadOnly}
                                    type="checkbox"
                                    name="signature"
                                    checked={flightDetailsTravelInterruption.manuallyEnterFlight === true}
                                    onChange={this.handleChange('form.flightDetailsTravelInterruption.manuallyEnterFlight')}
                                  />
                                  <span>
                                    <FormattedMessage {...messages.manuallyEnterFlight} />
                                  </span>
                                </OptionsContainer>
                              </div>
                              <div className={'form-group col-md-6'}>
                              </div>
                            </div>
                          )}
                          {(showSectionFlightDetails && flightDetailsTravelInterruption) && (
                            <div className={'row'}>
                              <div className={'col-sm-12'}>
                                <Section>
                                  <ControlContainer className={'ml-3'}>
                                    <div className={'row'}>
                                      <div className={'col-sm-2'}>
                                      </div>
                                      <div className={'col-sm-3'}>
                                        <h4>
                                          <FormattedMessage {...messages.flightDetails} />
                                        </h4>
                                      </div>
                                      <div className={'col-sm-3'}>
                                        <strong>
                                          <FormattedMessage {...messages.searchSuccess} />:
                                        </strong>{' '}
                                        {flightDetailsTravelInterruption.success ? 'Yes' : 'No'}
                                      </div>
                                      <div className={'col-sm-2'}>
                                      </div>
                                    </div>
                                    <div className={'row'}>
                                      <div className={'col-sm-6 form-group'}>
                                        <PageSectionHeader>
                                          <FormattedMessage {...messages.flightNumber} />
                                        </PageSectionHeader>
                                        <Textbox
                                          name="flightNumber"
                                          type="text"
                                          onChange={this.handleChange('form.flightDetailsTravelInterruption.flightNumber')}
                                          value={flightDetailsTravelInterruption.flightNumber}
                                          disabled={isDisable}
                                        />
                                      </div>
                                      <div className={'col-sm-6 form-group'}>
                                        <PageSectionHeader>
                                          <FormattedMessage {...messages.flightDate} />
                                        </PageSectionHeader>
                                        <DatePicker
                                          name="flightDate"
                                          type="text"
                                          onDayChange={this.handleDayChange('form.flightDetailsTravelInterruption.flightDate')}
                                          value={flightDetailsTravelInterruption.flightDate}
                                          disabled={isDisable}
                                        />
                                      </div>
                                    </div>
                                    <div className={'row'}>
                                      <div className={'col-sm-12 form-group'}>
                                        <PageSectionHeader>
                                          <FormattedMessage {...messages.airline} />
                                        </PageSectionHeader>
                                        <Textbox
                                          name="airline"
                                          type="text"
                                          onChange={this.handleChange('form.flightDetailsTravelInterruption.airline')}
                                          value={flightDetailsTravelInterruption.airline}
                                          disabled={isDisable}
                                        />
                                      </div>
                                    </div>
                                    <div className={'row'}>
                                      <div className={'col-sm-6 form-group'}>
                                        <PageSectionHeader>
                                          <FormattedMessage {...messages.originAirport} />
                                        </PageSectionHeader>
                                        <Textbox
                                          name="originAirport"
                                          type="text"
                                          onChange={this.handleChange('form.flightDetailsTravelInterruption.originAirport')}
                                          value={flightDetailsTravelInterruption.originAirport}
                                          disabled={isDisable}
                                        />
                                      </div>
                                      <div className={'col-sm-6 form-group'}>
                                        <PageSectionHeader>
                                          <FormattedMessage {...messages.destinationAirport} />
                                        </PageSectionHeader>
                                        <Textbox
                                          name="destinationAirport"
                                          type="text"
                                          onChange={this.handleChange('form.flightDetailsTravelInterruption.destinationAirport')}
                                          value={flightDetailsTravelInterruption.destinationAirport}
                                          disabled={isDisable}
                                        />
                                      </div>
                                    </div>
                                    <div className={'row'}>
                                      <div className={'col-sm-6 form-group'}>
                                        <PageSectionHeader>
                                          <FormattedMessage {...messages.scheduledOut} />
                                        </PageSectionHeader>
                                        <DatePicker
                                          name="scheduledOut"
                                          type="text"
                                          onDayChange={this.handleDayChange('form.flightDetailsTravelInterruption.scheduledOut')}
                                          value={flightDetailsTravelInterruption.scheduledOut}
                                          disabled={isDisable}
                                        />
                                      </div>
                                      <div className={'col-sm-6 form-group'}>
                                        <PageSectionHeader>
                                          <FormattedMessage {...messages.scheduledIn} />
                                        </PageSectionHeader>
                                        <DatePicker
                                          name="scheduledIn"
                                          type="text"
                                          onDayChange={this.handleDayChange('form.flightDetailsTravelInterruption.scheduledIn')}
                                          value={flightDetailsTravelInterruption.scheduledIn}
                                          disabled={isDisable}
                                        />
                                      </div>
                                    </div>
                                    <div className={'row'}>
                                      <div className={'col-sm-3 form-group'}>
                                        <PageSectionHeader>
                                          <FormattedMessage {...messages.departureDelay} />
                                        </PageSectionHeader>
                                        <Textbox
                                          name="departureDelay"
                                          type="number"
                                          onChange={this.handleChange('form.flightDetailsTravelInterruption.departureDelay')}
                                          value={flightDetailsTravelInterruption.departureDelay}
                                          disabled={isDisable}
                                        />
                                      </div>
                                      <div className={'col-sm-3 form-group'}>
                                        <PageSectionHeader>
                                          <FormattedMessage {...messages.arrivalDelay} />
                                        </PageSectionHeader>
                                        <Textbox
                                          name="arrivalDelay"
                                          type="number"
                                          onChange={this.handleChange('form.flightDetailsTravelInterruption.arrivalDelay')}
                                          value={flightDetailsTravelInterruption.arrivalDelay}
                                          disabled={isDisable}
                                        />
                                      </div>
                                      <div className={'col-sm-6 form-group'}>
                                        <PageSectionHeader>
                                          <FormattedMessage {...messages.cancelled} />
                                        </PageSectionHeader>
                                        <select
                                          name="cancelled"
                                          className="form-control"
                                          onChange={this.handleChange('form.flightDetailsTravelInterruption.cancelled')}
                                          value={flightDetailsTravelInterruption.cancelled || ''}
                                          disabled={isDisable}
                                        >
                                          <option value="">Select status</option>
                                          <option value="Yes">Yes</option>
                                          <option value="No">No</option>
                                        </select>
                                      </div>
                                    </div>
                                  </ControlContainer>
                                </Section>
                              </div>
                            </div>
                          )}
                        </div>
                      }
                      {typeOfTransportTravelInterruption === 'cruiseLine' &&
                        <div className={'ml-2'}>
                          <div className={'row'}>
                            <div className={'col-sm-6 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.cruiseLine} />
                              </PageSectionHeader>
                              <Textbox
                                name="cruiseLine"
                                type="text"
                                onChange={this.handleChange('form.cruiseLineDetailsTravelInterruption.cruiseLine')}
                                value={cruiseLineDetailsTravelInterruption.cruiseLine}
                                disabled={isReadOnly}
                              />
                            </div>
                            <div className={'col-sm-6 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.cruiseNumber} />
                              </PageSectionHeader>
                              <Textbox
                                name="cruiseNumber"
                                type="text"
                                onChange={this.handleChange('form.cruiseLineDetailsTravelInterruption.cruiseNumber')}
                                value={cruiseLineDetailsTravelInterruption.cruiseNumber}
                                disabled={isReadOnly}
                              />
                            </div>
                          </div>
                          <div className={'row'}>
                            <div className={'col-sm-6 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.departureDate} />
                              </PageSectionHeader>
                              <DatePicker
                                name="departureDate"
                                type="text"
                                onDayChange={this.handleDayChange('form.cruiseLineDetailsTravelInterruption.departureDate')}
                                value={cruiseLineDetailsTravelInterruption.departureDate}
                                disabled={isReadOnly}
                              />
                            </div>
                            <div className={'col-sm-6 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.arrivalDate} />
                              </PageSectionHeader>
                              <DatePicker
                                name="arrivalDate"
                                type="text"
                                onDayChange={this.handleDayChange('form.cruiseLineDetailsTravelInterruption.arrivalDate')}
                                value={cruiseLineDetailsTravelInterruption.arrivalDate}
                                disabled={isReadOnly}
                              />
                            </div>
                          </div>
                          <div className={'row'}>
                            <div className={'col-sm-6 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.departurePort} />
                              </PageSectionHeader>
                              <Textbox
                                name="departurePort"
                                type="text"
                                onChange={this.handleChange('form.cruiseLineDetailsTravelInterruption.departurePort')}
                                value={cruiseLineDetailsTravelInterruption.departurePort}
                                disabled={isReadOnly}
                              />
                            </div>
                            <div className={'col-sm-6 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.arrivalPort} />
                              </PageSectionHeader>
                              <Textbox
                                name="arrivalPort"
                                type="text"
                                onChange={this.handleChange('form.cruiseLineDetailsTravelInterruption.arrivalPort')}
                                value={cruiseLineDetailsTravelInterruption.arrivalPort}
                                disabled={isReadOnly}
                              />
                            </div>
                          </div>
                        </div>
                      }
                      {typeOfTransportTravelInterruption === 'other' &&
                        <div className={'ml-2'}>
                          <div className={'row'}>
                            <div className={'col-sm-12 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.pleaseDescribeDetailsOfYourJourneyAndWhatWasCancelled} />
                              </PageSectionHeader>
                              <TextArea
                                name="pleaseDescribeDetailsOfYourJourneyAndWhatWasCancelled"
                                type="text"
                                onChange={this.handleChange('form.otherDetailsTravelInterruption.pleaseDescribeDetailsOfYourJourneyAndWhatWasCancelled')}
                                value={otherDetailsTravelInterruption.pleaseDescribeDetailsOfYourJourneyAndWhatWasCancelled}
                                disabled={isReadOnly}
                              />
                            </div>
                          </div>
                          <div className={'row'}>
                            <div className={'col-sm-6 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.departureDate} />
                              </PageSectionHeader>
                              <DatePicker
                                name="departureDate"
                                type="text"
                                onDayChange={this.handleDayChange('form.otherDetailsTravelInterruption.departureDate')}
                                value={otherDetailsTravelInterruption.departureDate}
                                disabled={isReadOnly}
                              />
                            </div>
                          </div>
                          <div className={'row'}>
                            <div className={'col-sm-6 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.departureLocation} />
                              </PageSectionHeader>
                              <Textbox
                                name="departureLocation"
                                type="text"
                                onChange={this.handleChange('form.otherDetailsTravelInterruption.departureLocation')}
                                value={otherDetailsTravelInterruption.departureLocation}
                                disabled={isReadOnly}
                              />
                            </div>
                            <div className={'col-sm-6 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.destination} />
                              </PageSectionHeader>
                              <Textbox
                                name="destination"
                                type="text"
                                onChange={this.handleChange('form.otherDetailsTravelInterruption.destination')}
                                value={otherDetailsTravelInterruption.destination}
                                disabled={isReadOnly}
                              />
                            </div>
                          </div>
                          <div className={'row'}>
                            <div className={'col-sm-6 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.descriptionOfTravelType} />
                              </PageSectionHeader>
                              <Textbox
                                name="descriptionOfTravelType"
                                type="text"
                                onChange={this.handleChange('form.otherDetailsTravelInterruption.descriptionOfTravelType')}
                                value={otherDetailsTravelInterruption.descriptionOfTravelType}
                                disabled={isReadOnly}
                              />
                            </div>
                            <div className={'col-sm-6 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.descriptionOfEvent} />
                              </PageSectionHeader>
                              <Textbox
                                name="descriptionOfEvent"
                                type="text"
                                onChange={this.handleChange('form.otherDetailsTravelInterruption.descriptionOfEvent')}
                                value={otherDetailsTravelInterruption.descriptionOfEvent}
                                disabled={isReadOnly}
                              />
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={(isReadOnly || isOnlyOne) && !reasonsForTripInterruptions.includes('reasons8')}
                    type="checkbox"
                    name="reasons8"
                    checked={reasonsForTripInterruptions.includes('reasons8')}
                    onChange={this.handleReasonsForTripInterruption('form.reasonsForTripInterruption')}
                  />
                  <span>
                    <FormattedMessage {...messages.reasons8} />
                  </span>
                </div>
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={(isReadOnly || isOnlyOne) && !reasonsForTripInterruptions.includes('reasons9')}
                    type="checkbox"
                    name="reasons9"
                    checked={reasonsForTripInterruptions.includes('reasons9')}
                    onChange={this.handleReasonsForTripInterruption('form.reasonsForTripInterruption')}
                  />
                  <span>
                    <FormattedMessage {...messages.reasons9} />
                  </span>
                </div>
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={(isReadOnly || isOnlyOne) && !reasonsForTripInterruptions.includes('reasons10')}
                    type="checkbox"
                    name="reasons10"
                    checked={reasonsForTripInterruptions.includes('reasons10')}
                    onChange={this.handleReasonsForTripInterruption('form.reasonsForTripInterruption')}
                  />
                  <span>
                    <FormattedMessage {...messages.reasons10} />
                  </span>
                </div>
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={(isReadOnly || isOnlyOne) && !reasonsForTripInterruptions.includes('reasons11')}
                    type="checkbox"
                    name="reasons11"
                    checked={reasonsForTripInterruptions.includes('reasons11')}
                    onChange={this.handleReasonsForTripInterruption('form.reasonsForTripInterruption')}
                  />
                  <span>
                    <FormattedMessage {...messages.reasons11} />
                  </span>
                </div>
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={(isReadOnly || isOnlyOne) && !reasonsForTripInterruptions.includes('reasons12')}
                    type="checkbox"
                    name="reasons12"
                    checked={reasonsForTripInterruptions.includes('reasons12')}
                    onChange={this.handleReasonsForTripInterruption('form.reasonsForTripInterruption')}
                  />
                  <span>
                    <FormattedMessage {...messages.reasons12} />
                  </span>
                </div>
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={(isReadOnly || isOnlyOne) && !reasonsForTripInterruptions.includes('reasons13')}
                    type="checkbox"
                    name="reasons13"
                    checked={reasonsForTripInterruptions.includes('reasons13')}
                    onChange={this.handleReasonsForTripInterruption('form.reasonsForTripInterruption')}
                  />
                  <span>
                    <FormattedMessage {...messages.reasons13} />
                  </span>
                </div>
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={(isReadOnly || isOnlyOne) && !reasonsForTripInterruptions.includes('reasons15')}
                    type="checkbox"
                    name="reasons15"
                    checked={reasonsForTripInterruptions.includes('reasons15')}
                    onChange={this.handleReasonsForTripInterruption('form.reasonsForTripInterruption')}
                  />
                  <span>
                    <FormattedMessage {...messages.reasons15} />
                  </span>
                  {(isReasons15 && newVersion) &&
                    <div className={'ml-2 row'}>
                      <div className={'col-sm-12 form-group'}>
                        <Validate
                          name="reasonForInterruption"
                          validators={[required]}
                          group={this.validatorGroup}
                          addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                          validChangeInGroup={this.validatorGroup.validChangeInGroup}
                          validationCounter={this.state.validationCounter}
                          validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                          defaultValue={reasonForInterruption}
                          fieldName={messages.reasonForInterruption}
                        >
                          <TextArea
                            disabled={isReadOnly}
                            name="reasonForInterruption"
                            type="text"
                            onChange={this.handleChange('form.reasonForInterruption')}
                            value={reasonForInterruption}
                            isSummary={isSummary}
                          />
                          <ErrorMessage for="required">
                            <FormattedMessage
                              {...messages.isRequired}
                              values={messages.reasonForInterruption}
                            />
                          </ErrorMessage>
                        </Validate>
                      </div>
                    </div>
                  }
                </div>
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.reasonsForTripInterruption}
                  />
                </ErrorMessage>
              </Validate>
            </div>
          </div>
          {newVersion &&
            <div className={'ml-1 row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="dateTripInterrupted"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateTripInterrupted}
                  fieldName={messages.dateTripInterrupted}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateTripInterrupted"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateTripInterrupted')}
                    value={dateTripInterrupted}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateTripInterrupted}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateTripInterrupted}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-6 form-group'}>
              </div>
            </div>
          }
          {isClaimGroupAllowed &&
            <div className={'ml-3 row'}>
              <div className={'col-sm-12'}>
                <HelpText>
                  The amount you claim below is PER MEMBER. It needs to be an EQUAL amount claimed, for each person you selected in the page “What Happened”.
                  If you want to claim DIFFERENT amounts for each person, please create a SEPARATE CLAIM per person.
                </HelpText>
              </div>
            </div>
          }
          <div className={'ml-3 mt-3'}>
            <PageSectionHeader>
              <FormattedMessage
                {...(isClaimGroupAllowed ? messages.lossInformationPerPerson : messages.lossInformation)}
              />
            </PageSectionHeader>
            {this.renderTripInterruptionInformationItems()}
            {!newVersion &&
              <div className={'ml-2'}>
                <div className={'row'}>
                  <div className={'col-sm-4 form-group'}>
                    <Validate
                      name="dateTripInterrupted"
                      validators={[checkDateOnly, required]}
                      group={this.validatorGroup}
                      addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                      validChangeInGroup={this.validatorGroup.validChangeInGroup}
                      validationCounter={this.state.validationCounter}
                      validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                      defaultValue={dateTripInterrupted}
                      fieldName={messages.dateTripInterrupted}
                    >
                      <DatePicker
                        position={'bottom-start'}
                        disabled={isReadOnly}
                        name="dateTripInterrupted"
                        type="text"
                        onDayChange={this.handleDayChange('form.dateTripInterrupted')}
                        value={dateTripInterrupted}
                      />
                      <ErrorMessage for="required">
                        <FormattedMessage
                          {...messages.isRequired}
                          values={messages.dateTripInterrupted}
                        />
                      </ErrorMessage>
                      <ErrorMessage for="checkDateOnly">
                        <FormattedMessage
                          {...messages.checkEventDate}
                          values={messages.dateTripInterrupted}
                        />
                      </ErrorMessage>
                    </Validate>
                  </div>
                  <div className={'col-sm-8 form-group'}>
                  </div>
                </div>
                <div className={'row'}>
                  <div className={'col-sm-12 form-group'}>
                    <Validate
                      name="includedInPackage"
                      validators={[required]}
                      group={this.validatorGroup}
                      addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                      validChangeInGroup={this.validatorGroup.validChangeInGroup}
                      validationCounter={this.state.validationCounter}
                      validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                      defaultValue={reasonForInterruption}
                      fieldName={messages.reasonForInterruption}
                    >
                      <TextArea
                        disabled={isReadOnly}
                        name="reasonForInterruption"
                        type="text"
                        onChange={this.handleChange('form.reasonForInterruption')}
                        value={reasonForInterruption}
                        isSummary={isSummary}
                      />
                      <ErrorMessage for="required">
                        <FormattedMessage
                          {...messages.isRequired}
                          values={messages.reasonForInterruption}
                        />
                      </ErrorMessage>
                    </Validate>
                  </div>
                </div>
                <div className={'row'}>
                  <div className={'col-sm-5 form-group'}>
                    <PageSectionHeader>
                      <FormattedMessage {...messages.nameOfPersonHavingSickness} />
                    </PageSectionHeader>
                    <Textbox
                      name="nameOfPersonHavingSickness"
                      type="text"
                      onChange={this.handleChange('form.nameOfPersonHavingSickness')}
                      value={nameOfPersonHavingSickness}
                      disabled={isReadOnly}
                    />
                  </div>
                  <div className={'col-sm-3 form-group'}>
                    <PageSectionHeader>
                      <FormattedMessage {...messages.dateOfBirth} />
                    </PageSectionHeader>
                    <DatePicker
                      position={'bottom-start'}
                      disabled={isReadOnly}
                      name="dateOfBirth"
                      type="text"
                      onDayChange={this.handleDayChange('form.dateOfBirth')}
                      value={dateOfBirth}
                    />
                  </div>
                  <div className={'col-sm-4 form-group'}>
                    <PageSectionHeader>
                      <FormattedMessage {...messages.relationshipToClaimant} />
                    </PageSectionHeader>
                    <Textbox
                      name="relationshipToClaimant"
                      type="text"
                      onChange={this.handleChange('form.relationshipToClaimant')}
                      value={relationshipToClaimant}
                      disabled={isReadOnly}
                    />
                  </div>
                </div>
                <div className={'row'}>
                  <div className={'col-sm-4 form-group'}>
                    <PageSectionHeader>
                      <FormattedMessage {...messages.dateSicknessOrInjuryBegan} />
                    </PageSectionHeader>
                    <DatePicker
                      position={'bottom-start'}
                      disabled={isReadOnly}
                      name="dateSicknessOrInjuryBegan"
                      type="text"
                      onDayChange={this.handleDayChange('form.dateSicknessOrInjuryBegan')}
                      value={dateSicknessOrInjuryBegan}
                    />
                  </div>
                  <div className={'col-sm-4 form-group'}>
                    <PageSectionHeader>
                      <FormattedMessage {...messages.dateEnded} />
                    </PageSectionHeader>
                    <DatePicker
                      position={'bottom-start'}
                      disabled={isReadOnly}
                      name="dateEnded"
                      type="text"
                      onDayChange={this.handleDayChange('form.dateEnded')}
                      value={dateEnded}
                    />
                  </div>
                  <div className={'col-sm-4 form-group'}>
                  </div>
                </div>
                <div className={'row'}>
                  <div className={'col-sm-12 form-group'}>
                    <PageSectionHeader>
                      <FormattedMessage {...messages.natureOfSicknessOrInjury} />
                    </PageSectionHeader>
                    <TextArea
                      disabled={isReadOnly}
                      name="natureOfSicknessOrInjury"
                      type="text"
                      onChange={this.handleChange('form.natureOfSicknessOrInjury')}
                      value={natureOfSicknessOrInjury}
                      isSummary={isSummary}
                    />
                  </div>
                </div>
                <div className={'row'}>
                  <div className={'col-sm-12 form-group'}>
                    <PageSectionHeader>
                      <FormattedMessage {...messages.periodOfHospitalization} />
                    </PageSectionHeader>
                  </div>
                  <div className={'form-group col-sm-3'}>
                    <PageSectionHeader>
                      <FormattedMessage {...messages.fromDate} />
                    </PageSectionHeader>
                    <DatePicker
                      position={'bottom-start'}
                      disabled={isReadOnly}
                      name="fromDate"
                      type="text"
                      onDayChange={this.handleDayChange('form.fromDate')}
                      value={fromDate}
                    />
                  </div>
                  <div className={'form-group col-sm-3'}>
                    <PageSectionHeader>
                      <FormattedMessage {...messages.toDate} />
                    </PageSectionHeader>
                    <DatePicker
                      position={'bottom-start'}
                      disabled={isReadOnly}
                      name="toDate"
                      type="text"
                      onDayChange={this.handleDayChange('form.toDate')}
                      value={toDate}
                    />
                  </div>
                  <div className={'form-group col-sm-6'}>
                  </div>
                </div>
                <div className={'row'}>
                  <div className={'form-group col-sm-7'}>
                    <HelpText>
                      On clicking the button an email with the Statement of Attending Physician will be sent to you. Once sent please check your email.
                    </HelpText>
                  </div>
                  <div className={'form-group col-sm-5'}>
                    <AsyncButtonSendMail
                      id={this.emailMeDocumentButton}
                      className={buttonEmailMeDisable ? 'btn-action-success' : 'btn-authentication'}
                      disabled={buttonEmailMeDisable || isReadOnly}
                      loading={this.props.loading}
                      spinner={this.showSpinnerForElement(this.emailMeDocumentButton)}
                      onClick={this.handleEmailInterruption}
                    >
                      Statement of Attending Physician
                    </AsyncButtonSendMail>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      )
    );
  }

  renderTripInterruptionInformationItems() {
    const { lossInformationItems } = this.props.form;
    const newDelayInformationItems = this.appendIds(lossInformationItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newDelayInformationItems}
          onChange={this.onTripInterruptionChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderInsuredsTripInterruption() {
    const { insuredsForInterruption } = this.props.form;
    const newInsureds = this.appendIds(insuredsForInterruption);
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <InsuredList
          data={newInsureds}
          onChange={this.onInsuredTripInterruptionChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
        />
      </div>
    );
  }

  renderTravelSupplierTripInterruption() {
    const { travelSuppliersTravelInterruption } = this.props.form;
    const travelSuppliersTravelInterruptions = !!travelSuppliersTravelInterruption && typeof travelSuppliersTravelInterruption.toJS === 'function'
      ? travelSuppliersTravelInterruption.toJS()
      : travelSuppliersTravelInterruption || [];
    const newSuppliers = this.appendIds(travelSuppliersTravelInterruptions);
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <TravelSupplierList
          data={newSuppliers}
          onChange={this.onSupplierTripInterruption}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
        />
      </div>
    );
  }

  // Travel Cancellation
  renderTripCancellation() {
    const {
      tripCancellation,
      reasonForTripCancellation,
      areYouCancellingTheTripDueToMedicalReasons,
      dateTravelCancellation,
      reasonForTravelCancellation,
      nameOfPersonHavingSicknessTravelCancellation,
      dateOfBirthTravelCancellation,
      relationshipToClaimantTravelCancellation,
      dateSicknessOrInjuryBeganTravelCancellation,
      dateEndedTravelCancellation,
      natureOfSicknessOrInjuryTravelCancellation,
      fromDateTravelCancellation,
      toDateTravelCancellation,
      enableTimeTravelCancellation,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted, jsonVersion, isClaimGroupAllowed } = this.props;
    const buttonEmailMeDisable = !!enableTimeTravelCancellation && new Date().getTime() < enableTimeTravelCancellation;
    const isRenderTripCancellationForAnyReason = !!stepChangesToYourJourneyTrawickLookup.tripCancellationForAnyReason.claimCode;
    const reasonForTripCancellations = !!reasonForTripCancellation && typeof reasonForTripCancellation.toJS === 'function'
      ? reasonForTripCancellation.toJS()
      : reasonForTripCancellation || [];
    const newVersion = jsonVersion > 7;
    const isReadOnly = submitted || isSummary;
    const isOnlyOne = reasonForTripCancellations.length > 0;
    const isReason2 = reasonForTripCancellations.includes('reasons2');
    const isReason15 = reasonForTripCancellations.includes('reasons15');
    const isNoneOfTheAbove = reasonForTripCancellations.includes('None of the Above');
    const isReasonWeatherRelated = reasonForTripCancellations.includes('reasons7');
    return (
      tripCancellation === 'true' && (
        <div>
          {!newVersion &&
            <div className={'ml-3 row'}>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.areYouCancellingTheTripDueToMedicalReasons} />
                </PageSectionHeader>
                <FlexBox>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="true"
                      checked={areYouCancellingTheTripDueToMedicalReasons === 'true'}
                      onChange={this.handleChange('form.areYouCancellingTheTripDueToMedicalReasons')}
                    />
                    <FormattedMessage {...messages.yes} />
                  </OptionsContainer>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="false"
                      checked={areYouCancellingTheTripDueToMedicalReasons === 'false'}
                      onChange={this.handleChange('form.areYouCancellingTheTripDueToMedicalReasons')}
                    />
                    <FormattedMessage {...messages.no} />
                  </OptionsContainer>
                </FlexBox>
              </div>
            </div>
          }
          {!newVersion &&
            <div className={'ml-3'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.insureds} />
              </PageSectionHeader>
              {this.renderInsuredsTravelCancellation()}
            </div>
          }
          {newVersion &&
            <div className={'ml-3'}>
              <div className={'col-sm-12 form-group'}>
                <Validate
                  name="reasonsForTripCancellation"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={reasonForTripCancellations}
                  fieldName={messages.reasonsForTripCancellation}
                  tooltipContent={messages.reasonsForTripCancellationTooltip.defaultMessage}
                  tooltipDataFor={'reasonsForTripCancellationHint'}
                  tooltipPlace={'bottom'}
                >
                  <div className={'col-sm-12 form-group'}>
                    <input
                      disabled={(isReadOnly || isOnlyOne) && !reasonForTripCancellations.includes('reasons1')}
                      type="checkbox"
                      name="reasons1"
                      checked={reasonForTripCancellations.includes('reasons1')}
                      onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                    />
                    <span>
                      <FormattedMessage {...messages.reasons1} />
                    </span>
                  </div>
                  <div className={'col-sm-12 form-group'}>
                    <input
                      disabled={(isReadOnly || isOnlyOne) && !reasonForTripCancellations.includes('reasons2')}
                      type="checkbox"
                      name="reasons2"
                      checked={reasonForTripCancellations.includes('reasons2')}
                      onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                    />
                    <span>
                      <FormattedMessage {...messages.reasons2} />
                    </span>
                    {isReason2 === true &&
                      <div className={'col-sm-12 form-group'}>
                        <div className={'ml-2 row'}>
                          <div className={'col-sm-5 form-group'}>
                            <PageSectionHeader>
                              <FormattedMessage {...messages.nameOfPersonHavingSickness} />
                            </PageSectionHeader>
                            <Textbox
                              name="nameOfPersonHavingSicknessTravelCancellation"
                              type="text"
                              onChange={this.handleChange('form.nameOfPersonHavingSicknessTravelCancellation')}
                              value={nameOfPersonHavingSicknessTravelCancellation}
                              disabled={isReadOnly}
                            />
                          </div>
                          <div className={'col-sm-3 form-group'}>
                            <PageSectionHeader>
                              <FormattedMessage {...messages.dateOfBirth} />
                            </PageSectionHeader>
                            <DatePicker
                              position={'bottom-start'}
                              disabled={isReadOnly}
                              name="dateOfBirthTravelCancellation"
                              type="text"
                              onDayChange={this.handleDayChange('form.dateOfBirthTravelCancellation')}
                              value={dateOfBirthTravelCancellation}
                            />
                          </div>
                          <div className={'col-sm-4 form-group'}>
                            <PageSectionHeader>
                              <FormattedMessage {...messages.relationshipToClaimant} />
                            </PageSectionHeader>
                            <Textbox
                              name="relationshipToClaimantTravelCancellation"
                              type="text"
                              onChange={this.handleChange('form.relationshipToClaimantTravelCancellation')}
                              value={relationshipToClaimantTravelCancellation}
                              disabled={isReadOnly}
                            />
                          </div>
                        </div>
                        <div className={'ml-2 row'}>
                          <div className={'col-sm-4 form-group'}>
                            <PageSectionHeader>
                              <FormattedMessage {...messages.dateSicknessOrInjuryBegan} />
                            </PageSectionHeader>
                            <DatePicker
                              position={'bottom-start'}
                              disabled={isReadOnly}
                              name="dateSicknessOrInjuryBeganTravelCancellation"
                              type="text"
                              onDayChange={this.handleDayChange('form.dateSicknessOrInjuryBeganTravelCancellation')}
                              value={dateSicknessOrInjuryBeganTravelCancellation}
                            />
                          </div>
                          <div className={'col-sm-4 form-group'}>
                            <PageSectionHeader>
                              <FormattedMessage {...messages.dateEnded} />
                            </PageSectionHeader>
                            <DatePicker
                              position={'bottom-start'}
                              disabled={isReadOnly}
                              name="dateEndedTravelCancellation"
                              type="text"
                              onDayChange={this.handleDayChange('form.dateEndedTravelCancellation')}
                              value={dateEndedTravelCancellation}
                            />
                          </div>
                          <div className={'col-sm-4 form-group'}>
                          </div>
                        </div>
                        <div className={'ml-2 row'}>
                          <div className={'col-sm-12 form-group'}>
                            <PageSectionHeader>
                              <FormattedMessage {...messages.natureOfSicknessOrInjury} />
                            </PageSectionHeader>
                            <TextArea
                              disabled={isReadOnly}
                              name="natureOfSicknessOrInjuryTravelCancellation"
                              type="text"
                              onChange={this.handleChange('form.natureOfSicknessOrInjuryTravelCancellation')}
                              value={natureOfSicknessOrInjuryTravelCancellation}
                              isSummary={isSummary}
                            />
                          </div>
                        </div>
                        <div className={'ml-2 row'}>
                          <div className={'col-sm-12 form-group'}>
                            <PageSectionHeader>
                              <FormattedMessage {...messages.periodOfHospitalization} />
                            </PageSectionHeader>
                          </div>
                          <div className={'form-group col-sm-3'}>
                            <PageSectionHeader>
                              <FormattedMessage {...messages.fromDate} />
                            </PageSectionHeader>
                            <DatePicker
                              position={'bottom-start'}
                              disabled={isReadOnly}
                              name="fromDateTravelCancellation"
                              type="text"
                              onDayChange={this.handleDayChange('form.fromDateTravelCancellation')}
                              value={fromDateTravelCancellation}
                            />
                          </div>
                          <div className={'form-group col-sm-3'}>
                            <PageSectionHeader>
                              <FormattedMessage {...messages.toDate} />
                            </PageSectionHeader>
                            <DatePicker
                              position={'bottom-start'}
                              disabled={isReadOnly}
                              name="toDateTravelCancellation"
                              type="text"
                              onDayChange={this.handleDayChange('form.toDateTravelCancellation')}
                              value={toDateTravelCancellation}
                            />
                          </div>
                          <div className={'form-group col-sm-6'}>
                          </div>
                        </div>
                        <div className={'ml-2 row'}>
                          <div className={'form-group col-sm-7'}>
                            <HelpText>
                              On clicking the button an email with the Statement of Attending Physician will be sent to you. Once sent please check your email.
                            </HelpText>
                          </div>
                          <div className={'form-group col-sm-5'}>
                            <AsyncButtonSendMail
                              id={this.emailMeDocumentButton}
                              className={buttonEmailMeDisable ? 'btn-action-success' : 'btn-authentication'}
                              disabled={buttonEmailMeDisable || isReadOnly}
                              loading={this.props.loading}
                              spinner={this.showSpinnerForElement(this.emailMeDocumentButton)}
                              onClick={this.handleEmailMeButtonClick}
                            >
                              Statement of Attending Physician
                            </AsyncButtonSendMail>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                  <div className={'col-sm-12 form-group'}>
                    <input
                      disabled={(isReadOnly || isOnlyOne) && !reasonForTripCancellations.includes('reasons3')}
                      type="checkbox"
                      name="reasons3"
                      checked={reasonForTripCancellations.includes('reasons3')}
                      onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                    />
                    <span>
                      <FormattedMessage {...messages.reasons3} />
                    </span>
                  </div>
                  <div className={'col-sm-12 form-group'}>
                    <input
                      disabled={(isReadOnly || isOnlyOne) && !reasonForTripCancellations.includes('reasons4')}
                      type="checkbox"
                      name="reasons4"
                      checked={reasonForTripCancellations.includes('reasons4')}
                      onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                    />
                    <span>
                      <FormattedMessage {...messages.reasons4} />
                    </span>
                  </div>
                  <div className={'col-sm-12 form-group'}>
                    <input
                      disabled={(isReadOnly || isOnlyOne) && !reasonForTripCancellations.includes('reasons5')}
                      type="checkbox"
                      name="reasons5"
                      checked={reasonForTripCancellations.includes('reasons5')}
                      onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                    />
                    <span>
                      <FormattedMessage {...messages.reasons5} />
                    </span>
                  </div>
                  <div className={'col-sm-12 form-group'}>
                    <input
                      disabled={(isReadOnly || isOnlyOne) && !reasonForTripCancellations.includes('reasons6')}
                      type="checkbox"
                      name="reasons6"
                      checked={reasonForTripCancellations.includes('reasons6')}
                      onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                    />
                    <span>
                      <FormattedMessage {...messages.reasons6} />
                    </span>
                  </div>
                  <div className={'col-sm-12 form-group'}>
                    <input
                      disabled={(isReadOnly || isOnlyOne) && !reasonForTripCancellations.includes('reasons7')}
                      type="checkbox"
                      name="reasons7"
                      checked={reasonForTripCancellations.includes('reasons7')}
                      onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                    />
                    <span>
                      <FormattedMessage {...messages.reasons7} />
                    </span>
                    {isReasonWeatherRelated === true &&
                      <div>
                        <div className={'pt-2'} style={{ fontWeight: 'bold' }}>
                          <FormattedMessage {...messages.typeOfTransport} />
                        </div>
                        <div className={'ml-2 row pt-2'}>
                          <div className={'col-sm-12 form-group'}>
                            <FlexBox>
                              <OptionsContainer>
                                <input
                                  disabled={isReadOnly}
                                  type="radio"
                                  value="airline"
                                  checked={typeOfTransportTravelCancellation === 'airline'}
                                  onChange={this.handleChangeTypeOfTransport('form.typeOfTransportTravelCancellation')}
                                />
                                <FormattedMessage {...messages.airline} />
                              </OptionsContainer>
                              <OptionsContainer>
                                <input
                                  disabled={isReadOnly}
                                  type="radio"
                                  value="cruiseLine"
                                  checked={typeOfTransportTravelCancellation === 'cruiseLine'}
                                  onChange={this.handleChangeTypeOfTransport('form.typeOfTransportTravelCancellation')}
                                />
                                <FormattedMessage {...messages.cruiseLine} />
                              </OptionsContainer>
                              <OptionsContainer>
                                <input
                                  disabled={isReadOnly}
                                  type="radio"
                                  value="other"
                                  checked={typeOfTransportTravelCancellation === 'other'}
                                  onChange={this.handleChangeTypeOfTransport('form.typeOfTransportTravelCancellation')}
                                />
                                <FormattedMessage {...messages.other} />
                              </OptionsContainer>
                            </FlexBox>
                          </div>
                        </div>
                        {typeOfTransportTravelCancellation === 'airline' &&
                          <div className={'ml-2'}>
                            <PageSectionHeader>
                              <FormattedMessage {...messages.pleaseEnterYourFlightNumberAndDateBelow} />
                            </PageSectionHeader>
                            <div className={'row'}>
                              <div className={'col-sm-4 form-group'}>
                                <Validate
                                  name="flightNumber"
                                  validators={[checkFlightNumberOnly, required]}
                                  group={this.validatorGroup}
                                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                                  validationCounter={this.state.validationCounter}
                                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                                  defaultValue={flightNumber}
                                  fieldName={messages.flightNumber}
                                >
                                  <Textbox
                                    name="flightNumber"
                                    type="text"
                                    onChange={this.handleChange('form.flightNumber')}
                                    value={flightNumber}
                                    disabled={isReadOnly}
                                  />
                                  <ErrorMessage for="required">
                                    <FormattedMessage
                                      {...messages.isRequired}
                                      values={messages.flightNumber}
                                    />
                                  </ErrorMessage>
                                  <ErrorMessage for="checkFlightNumberOnly">
                                    <FormattedMessage
                                      {...messages.checkFlightNumber}
                                      values={messages.flightNumber}
                                    />
                                  </ErrorMessage>
                                </Validate>
                              </div>
                              <div className={'col-sm-4 form-group'}>
                                <Validate
                                  name="flightDate"
                                  validators={[checkFlightDateOnly, required]}
                                  group={this.validatorGroup}
                                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                                  validationCounter={this.state.validationCounter}
                                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                                  defaultValue={flightDate}
                                  fieldName={messages.flightDate}
                                >
                                  <FlightDatePicker
                                    position={'bottom-start'}
                                    disabled={isReadOnly}
                                    name="flightDate"
                                    type="text"
                                    onDayChange={this.handleDayChange('form.flightDate')}
                                    value={flightDate}
                                  />
                                  <ErrorMessage for="required">
                                    <FormattedMessage
                                      {...messages.isRequired}
                                      values={messages.flightDate}
                                    />
                                  </ErrorMessage>
                                  <ErrorMessage for="checkFlightDateOnly">
                                    <FormattedMessage
                                      {...messages.checkFlightDate}
                                      values={messages.flightDate}
                                    />
                                  </ErrorMessage>
                                </Validate>
                              </div>
                              <div className={'col-sm-2 form-group'}></div>
                            </div>
                            <div className={'row'}>
                              <div className={'col-sm-12 form-group'}>
                                <AsyncButton
                                  id="searchFlightButton"
                                  className={'btn-authentication'}
                                  disabled={isReadOnly || (!isFlightNumberValid && !isFlightDateValid)}
                                  loading={this.props.loading}
                                  spinner={this.showSpinnerForElement('searchFlightButton')}
                                  onClick={this.flightVerificationTravelCancellation('flightDetailsTravelCancellation')}
                                >
                                  Search Flight
                                </AsyncButton>
                              </div>
                            </div>
                            {flightDetailsTravelCancellation.onPendingFlighAPIRequest && (
                              <div className={'ml-2 row'}>
                                <div style={{ fontWeight: 'bold' }}>
                                  <FormattedMessage {...messages.pendingFlightApiRequest} />
                                </div>
                              </div>
                            )}
                            {flightDetailsTravelCancellation.callFailFlighAPIRequest && flightDetailsTravelCancellation && flightDetailsTravelCancellation.error && (
                              <div className={'row'}>
                                <div className={'col-sm-12'} style={{ color: 'red' }}>
                                  {flightDetailsTravelCancellation.error}
                                </div>
                              </div>
                            )}
                            {flightDetailsTravelCancellation.callFailFlighAPIRequest && flightDetailsTravelCancellation && flightDetailsTravelCancellation.error && (
                              <div className={'row'}>
                                <div className={'form-group col-md-6'}>
                                  <OptionsContainer>
                                    <input
                                      disabled={isReadOnly}
                                      type="checkbox"
                                      name="signature"
                                      checked={flightDetailsTravelCancellation.manuallyEnterFlight === true}
                                      onChange={this.handleChange('form.flightDetailsTravelCancellation.manuallyEnterFlight')}
                                    />
                                    <span>
                                      <FormattedMessage {...messages.manuallyEnterFlight} />
                                    </span>
                                  </OptionsContainer>
                                </div>
                                <div className={'form-group col-md-6'}>
                                </div>
                              </div>
                            )}
                            {(showSectionFlightDetails && flightDetailsTravelCancellation) && (
                              <div className={'row'}>
                                <div className={'col-sm-12'}>
                                  <Section>
                                    <ControlContainer className={'ml-3'}>
                                      <div className={'row'}>
                                        <div className={'col-sm-2'}>
                                        </div>
                                        <div className={'col-sm-3'}>
                                          <h4>
                                            <FormattedMessage {...messages.flightDetails} />
                                          </h4>
                                        </div>
                                        <div className={'col-sm-3'}>
                                          <strong>
                                            <FormattedMessage {...messages.searchSuccess} />:
                                          </strong>{' '}
                                          {flightDetailsTravelCancellation.success ? 'Yes' : 'No'}
                                        </div>
                                        <div className={'col-sm-2'}>
                                        </div>
                                      </div>
                                      <div className={'row'}>
                                        <div className={'col-sm-6 form-group'}>
                                          <PageSectionHeader>
                                            <FormattedMessage {...messages.flightNumber} />
                                          </PageSectionHeader>
                                          <Textbox
                                            name="flightNumber"
                                            type="text"
                                            onChange={this.handleChange('form.flightDetailsTravelCancellation.flightNumber')}
                                            value={flightDetailsTravelCancellation.flightNumber}
                                            disabled={isDisable}
                                          />
                                        </div>
                                        <div className={'col-sm-6 form-group'}>
                                          <PageSectionHeader>
                                            <FormattedMessage {...messages.flightDate} />
                                          </PageSectionHeader>
                                          <DatePicker
                                            name="flightDate"
                                            type="text"
                                            onDayChange={this.handleDayChange('form.flightDetailsTravelCancellation.flightDate')}
                                            value={flightDetailsTravelCancellation.flightDate}
                                            disabled={isDisable}
                                          />
                                        </div>
                                      </div>
                                      <div className={'row'}>
                                        <div className={'col-sm-12 form-group'}>
                                          <PageSectionHeader>
                                            <FormattedMessage {...messages.airline} />
                                          </PageSectionHeader>
                                          <Textbox
                                            name="airline"
                                            type="text"
                                            onChange={this.handleChange('form.flightDetailsTravelCancellation.airline')}
                                            value={flightDetailsTravelCancellation.airline}
                                            disabled={isDisable}
                                          />
                                        </div>
                                      </div>
                                      <div className={'row'}>
                                        <div className={'col-sm-6 form-group'}>
                                          <PageSectionHeader>
                                            <FormattedMessage {...messages.originAirport} />
                                          </PageSectionHeader>
                                          <Textbox
                                            name="originAirport"
                                            type="text"
                                            onChange={this.handleChange('form.flightDetailsTravelCancellation.originAirport')}
                                            value={flightDetailsTravelCancellation.originAirport}
                                            disabled={isDisable}
                                          />
                                        </div>
                                        <div className={'col-sm-6 form-group'}>
                                          <PageSectionHeader>
                                            <FormattedMessage {...messages.destinationAirport} />
                                          </PageSectionHeader>
                                          <Textbox
                                            name="destinationAirport"
                                            type="text"
                                            onChange={this.handleChange('form.flightDetailsTravelCancellation.destinationAirport')}
                                            value={flightDetailsTravelCancellation.destinationAirport}
                                            disabled={isDisable}
                                          />
                                        </div>
                                      </div>
                                      <div className={'row'}>
                                        <div className={'col-sm-6 form-group'}>
                                          <PageSectionHeader>
                                            <FormattedMessage {...messages.scheduledOut} />
                                          </PageSectionHeader>
                                          <DatePicker
                                            name="scheduledOut"
                                            type="text"
                                            onDayChange={this.handleDayChange('form.flightDetailsTravelCancellation.scheduledOut')}
                                            value={flightDetailsTravelCancellation.scheduledOut}
                                            disabled={isDisable}
                                          />
                                        </div>
                                        <div className={'col-sm-6 form-group'}>
                                          <PageSectionHeader>
                                            <FormattedMessage {...messages.scheduledIn} />
                                          </PageSectionHeader>
                                          <DatePicker
                                            name="scheduledIn"
                                            type="text"
                                            onDayChange={this.handleDayChange('form.flightDetailsTravelCancellation.scheduledIn')}
                                            value={flightDetailsTravelCancellation.scheduledIn}
                                            disabled={isDisable}
                                          />
                                        </div>
                                      </div>
                                      <div className={'row'}>
                                        <div className={'col-sm-3 form-group'}>
                                          <PageSectionHeader>
                                            <FormattedMessage {...messages.departureDelay} />
                                          </PageSectionHeader>
                                          <Textbox
                                            name="departureDelay"
                                            type="number"
                                            onChange={this.handleChange('form.flightDetailsTravelCancellation.departureDelay')}
                                            value={flightDetailsTravelCancellation.departureDelay}
                                            disabled={isDisable}
                                          />
                                        </div>
                                        <div className={'col-sm-3 form-group'}>
                                          <PageSectionHeader>
                                            <FormattedMessage {...messages.arrivalDelay} />
                                          </PageSectionHeader>
                                          <Textbox
                                            name="arrivalDelay"
                                            type="number"
                                            onChange={this.handleChange('form.flightDetailsTravelCancellation.arrivalDelay')}
                                            value={flightDetailsTravelCancellation.arrivalDelay}
                                            disabled={isDisable}
                                          />
                                        </div>
                                        <div className={'col-sm-6 form-group'}>
                                          <PageSectionHeader>
                                            <FormattedMessage {...messages.cancelled} />
                                          </PageSectionHeader>
                                          <select
                                            name="cancelled"
                                            className="form-control"
                                            onChange={this.handleChange('form.flightDetailsTravelCancellation.cancelled')}
                                            value={flightDetailsTravelCancellation.cancelled || ''}
                                            disabled={isDisable}
                                          >
                                            <option value="">Select status</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                          </select>
                                        </div>
                                      </div>
                                    </ControlContainer>
                                  </Section>
                                </div>
                              </div>
                            )}
                          </div>
                        }
                        {typeOfTransportTravelCancellation === 'cruiseLine' &&
                          <div className={'ml-2'}>
                            <div className={'row'}>
                              <div className={'col-sm-6 form-group'}>
                                <PageSectionHeader>
                                  <FormattedMessage {...messages.cruiseLine} />
                                </PageSectionHeader>
                                <Textbox
                                  name="cruiseLine"
                                  type="text"
                                  onChange={this.handleChange('form.cruiseLineDetailsTravelCancellation.cruiseLine')}
                                  value={cruiseLineDetailsTravelCancellation.cruiseLine}
                                  disabled={isReadOnly}
                                />
                              </div>
                              <div className={'col-sm-6 form-group'}>
                                <PageSectionHeader>
                                  <FormattedMessage {...messages.cruiseNumber} />
                                </PageSectionHeader>
                                <Textbox
                                  name="cruiseNumber"
                                  type="text"
                                  onChange={this.handleChange('form.cruiseLineDetailsTravelCancellation.cruiseNumber')}
                                  value={cruiseLineDetailsTravelCancellation.cruiseNumber}
                                  disabled={isReadOnly}
                                />
                              </div>
                            </div>
                            <div className={'row'}>
                              <div className={'col-sm-6 form-group'}>
                                <PageSectionHeader>
                                  <FormattedMessage {...messages.departureDate} />
                                </PageSectionHeader>
                                <DatePicker
                                  name="departureDate"
                                  type="text"
                                  onDayChange={this.handleDayChange('form.cruiseLineDetailsTravelCancellation.departureDate')}
                                  value={cruiseLineDetailsTravelCancellation.departureDate}
                                  disabled={isReadOnly}
                                />
                              </div>
                              <div className={'col-sm-6 form-group'}>
                                <PageSectionHeader>
                                  <FormattedMessage {...messages.arrivalDate} />
                                </PageSectionHeader>
                                <DatePicker
                                  name="arrivalDate"
                                  type="text"
                                  onDayChange={this.handleDayChange('form.cruiseLineDetailsTravelCancellation.arrivalDate')}
                                  value={cruiseLineDetailsTravelCancellation.arrivalDate}
                                  disabled={isReadOnly}
                                />
                              </div>
                            </div>
                            <div className={'row'}>
                              <div className={'col-sm-6 form-group'}>
                                <PageSectionHeader>
                                  <FormattedMessage {...messages.departurePort} />
                                </PageSectionHeader>
                                <Textbox
                                  name="departurePort"
                                  type="text"
                                  onChange={this.handleChange('form.cruiseLineDetailsTravelCancellation.departurePort')}
                                  value={cruiseLineDetailsTravelCancellation.departurePort}
                                  disabled={isReadOnly}
                                />
                              </div>
                              <div className={'col-sm-6 form-group'}>
                                <PageSectionHeader>
                                  <FormattedMessage {...messages.arrivalPort} />
                                </PageSectionHeader>
                                <Textbox
                                  name="arrivalPort"
                                  type="text"
                                  onChange={this.handleChange('form.cruiseLineDetailsTravelCancellation.arrivalPort')}
                                  value={cruiseLineDetailsTravelCancellation.arrivalPort}
                                  disabled={isReadOnly}
                                />
                              </div>
                            </div>
                          </div>
                        }
                        {typeOfTransportTravelCancellation === 'other' &&
                          <div className={'ml-2'}>
                            <div className={'row'}>
                              <div className={'col-sm-12 form-group'}>
                                <PageSectionHeader>
                                  <FormattedMessage {...messages.pleaseDescribeDetailsOfYourJourneyAndWhatWasCancelled} />
                                </PageSectionHeader>
                                <TextArea
                                  name="pleaseDescribeDetailsOfYourJourneyAndWhatWasCancelled"
                                  type="text"
                                  onChange={this.handleChange('form.otherDetailsTravelCancellation.pleaseDescribeDetailsOfYourJourneyAndWhatWasCancelled')}
                                  value={otherDetailsTravelCancellation.pleaseDescribeDetailsOfYourJourneyAndWhatWasCancelled}
                                  disabled={isReadOnly}
                                />
                              </div>
                            </div>
                            <div className={'row'}>
                              <div className={'col-sm-6 form-group'}>
                                <PageSectionHeader>
                                  <FormattedMessage {...messages.departureDate} />
                                </PageSectionHeader>
                                <DatePicker
                                  name="departureDate"
                                  type="text"
                                  onDayChange={this.handleDayChange('form.otherDetailsTravelCancellation.departureDate')}
                                  value={otherDetailsTravelCancellation.departureDate}
                                  disabled={isReadOnly}
                                />
                              </div>
                            </div>
                            <div className={'row'}>
                              <div className={'col-sm-6 form-group'}>
                                <PageSectionHeader>
                                  <FormattedMessage {...messages.departureLocation} />
                                </PageSectionHeader>
                                <Textbox
                                  name="departureLocation"
                                  type="text"
                                  onChange={this.handleChange('form.otherDetailsTravelCancellation.departureLocation')}
                                  value={otherDetailsTravelCancellation.departureLocation}
                                  disabled={isReadOnly}
                                />
                              </div>
                              <div className={'col-sm-6 form-group'}>
                                <PageSectionHeader>
                                  <FormattedMessage {...messages.destination} />
                                </PageSectionHeader>
                                <Textbox
                                  name="destination"
                                  type="text"
                                  onChange={this.handleChange('form.otherDetailsTravelCancellation.destination')}
                                  value={otherDetailsTravelCancellation.destination}
                                  disabled={isReadOnly}
                                />
                              </div>
                            </div>
                            <div className={'row'}>
                              <div className={'col-sm-6 form-group'}>
                                <PageSectionHeader>
                                  <FormattedMessage {...messages.descriptionOfTravelType} />
                                </PageSectionHeader>
                                <Textbox
                                  name="descriptionOfTravelType"
                                  type="text"
                                  onChange={this.handleChange('form.otherDetailsTravelCancellation.descriptionOfTravelType')}
                                  value={otherDetailsTravelCancellation.descriptionOfTravelType}
                                  disabled={isReadOnly}
                                />
                              </div>
                              <div className={'col-sm-6 form-group'}>
                                <PageSectionHeader>
                                  <FormattedMessage {...messages.descriptionOfEvent} />
                                </PageSectionHeader>
                                <Textbox
                                  name="descriptionOfEvent"
                                  type="text"
                                  onChange={this.handleChange('form.otherDetailsTravelCancellation.descriptionOfEvent')}
                                  value={otherDetailsTravelCancellation.descriptionOfEvent}
                                  disabled={isReadOnly}
                                />
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </div>
                  <div className={'col-sm-12 form-group'}>
                    <input
                      disabled={(isReadOnly || isOnlyOne) && !reasonForTripCancellations.includes('reasons8')}
                      type="checkbox"
                      name="reasons8"
                      checked={reasonForTripCancellations.includes('reasons8')}
                      onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                    />
                    <span>
                      <FormattedMessage {...messages.reasons8} />
                    </span>
                  </div>
                  <div className={'col-sm-12 form-group'}>
                    <input
                      disabled={(isReadOnly || isOnlyOne) && !reasonForTripCancellations.includes('reasons9')}
                      type="checkbox"
                      name="reasons9"
                      checked={reasonForTripCancellations.includes('reasons9')}
                      onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                    />
                    <span>
                      <FormattedMessage {...messages.reasons9} />
                    </span>
                  </div>
                  <div className={'col-sm-12 form-group'}>
                    <input
                      disabled={(isReadOnly || isOnlyOne) && !reasonForTripCancellations.includes('reasons10')}
                      type="checkbox"
                      name="reasons10"
                      checked={reasonForTripCancellations.includes('reasons10')}
                      onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                    />
                    <span>
                      <FormattedMessage {...messages.reasons10} />
                    </span>
                  </div>
                  <div className={'col-sm-12 form-group'}>
                    <input
                      disabled={(isReadOnly || isOnlyOne) && !reasonForTripCancellations.includes('reasons11')}
                      type="checkbox"
                      name="reasons11"
                      checked={reasonForTripCancellations.includes('reasons11')}
                      onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                    />
                    <span>
                      <FormattedMessage {...messages.reasons11} />
                    </span>
                  </div>
                  <div className={'col-sm-12 form-group'}>
                    <input
                      disabled={(isReadOnly || isOnlyOne) && !reasonForTripCancellations.includes('reasons12')}
                      type="checkbox"
                      name="reasons12"
                      checked={reasonForTripCancellations.includes('reasons12')}
                      onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                    />
                    <span>
                      <FormattedMessage {...messages.reasons12} />
                    </span>
                  </div>
                  <div className={'col-sm-12 form-group'}>
                    <input
                      disabled={(isReadOnly || isOnlyOne) && !reasonForTripCancellations.includes('reasons13')}
                      type="checkbox"
                      name="reasons13"
                      checked={reasonForTripCancellations.includes('reasons13')}
                      onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                    />
                    <span>
                      <FormattedMessage {...messages.reasons13} />
                    </span>
                  </div>
                  {/* None of the Above (Cancel For Any Reason) */}
                  <div className={'col-sm-12 form-group'} style={{ display: isRenderTripCancellationForAnyReason ? 'none' : '' }}>
                    <input
                      disabled={(isReadOnly || isOnlyOne) && !reasonForTripCancellations.includes('reasons15')}
                      type="checkbox"
                      name="reasons15"
                      checked={reasonForTripCancellations.includes('reasons15')}
                      onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                    />
                    <span>
                      <FormattedMessage {...messages.other} />
                    </span>
                    {isReason15 === true &&
                      <div className={'ml-2 row'}>
                        <div className={'col-sm-12 form-group'}>
                          <Validate
                            name="other"
                            validators={[required]}
                            group={this.validatorGroup}
                            addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                            validChangeInGroup={this.validatorGroup.validChangeInGroup}
                            validationCounter={this.state.validationCounter}
                            validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                            defaultValue={reasonForTravelCancellation}
                            fieldName={messages.reasonForCancellation}
                          >
                            <TextArea
                              name="reasonForAirlineReissue"
                              type="text"
                              onChange={this.handleChange('form.reasonForTravelCancellation')}
                              value={reasonForTravelCancellation}
                              disabled={isReadOnly}
                            />
                            <ErrorMessage for="required">
                              <FormattedMessage
                                {...messages.isRequired}
                                values={messages.other}
                              />
                            </ErrorMessage>
                          </Validate>
                        </div>
                      </div>
                    }
                  </div>
                  {/* None of the Above (Cancel For Any Reason) */}
                  <div className={'col-sm-12 form-group'} style={{ display: !isRenderTripCancellationForAnyReason ? 'none' : '' }}>
                    <input
                      disabled={(isReadOnly || isOnlyOne) && !reasonForTripCancellations.includes('None of the Above')}
                      type="checkbox"
                      name="None of the Above"
                      checked={reasonForTripCancellations.includes('None of the Above')}
                      onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                    />
                    <span style={{ fontWeight: 'bold' }}>
                      <FormattedMessage {...messages.noneOfTheAbove} />
                      <FNOLTooltip place={'top'} dataFor={'noneOfTheAboveHint'} content={messages.noneOfTheAboveTooltip.defaultMessage} />
                    </span>
                    {isNoneOfTheAbove === true &&
                      <div className={'ml-2 row'}>
                        <div className={'col-sm-12 form-group'}>
                          <Validate
                            name="reasonForCancellation"
                            validators={[required]}
                            group={this.validatorGroup}
                            addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                            validChangeInGroup={this.validatorGroup.validChangeInGroup}
                            validationCounter={this.state.validationCounter}
                            validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                            defaultValue={reasonForTravelCancellation}
                            fieldName={messages.reasonForCancellation}
                          >
                            <TextArea
                              name="reasonForAirlineReissue"
                              type="text"
                              onChange={this.handleChange('form.reasonForTravelCancellation')}
                              value={reasonForTravelCancellation}
                              disabled={isReadOnly}
                            />
                            <ErrorMessage for="required">
                              <FormattedMessage
                                {...messages.isRequired}
                                values={messages.reasonForCancellation}
                              />
                            </ErrorMessage>
                          </Validate>
                        </div>
                      </div>
                    }
                  </div>
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.reasonsForTripCancellation}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
            </div>
          }
          {newVersion &&
            <div className={'ml-2 row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="dateTravelCancellation"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateTravelCancellation}
                  fieldName={messages.dateTripWasCancelledWithTravelSupplier}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateTravelCancellation"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateTravelCancellation')}
                    value={dateTravelCancellation}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateTripWasCancelledWithTravelSupplier}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateTripWasCancelledWithTravelSupplier}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-6 form-group'}>
              </div>
            </div>
          }
          {isClaimGroupAllowed &&
            <div className={'ml-3 row'}>
              <div className={'col-sm-12'}>
                <HelpText>
                  {messages.equalAmountClaimNote.defaultMessage}
                </HelpText>
              </div>
            </div>}
          <div className={'ml-3 mt-3'}>
            <PageSectionHeader>
              <FormattedMessage
                {...(isClaimGroupAllowed ? messages.lossInformationPerPerson : messages.lossInformation)}
              />
            </PageSectionHeader>
            {this.renderTravelCancellationAdditionalItems()}
            {!newVersion &&
              <div className={'ml-2 row'}>
                <div className={'col-sm-6 form-group'}>
                  <Validate
                    name="dateTravelCancellation"
                    validators={[checkDateOnly, required]}
                    group={this.validatorGroup}
                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                    validationCounter={this.state.validationCounter}
                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                    defaultValue={dateTravelCancellation}
                    fieldName={messages.dateTripWasCancelledWithTravelSupplier}
                  >
                    <DatePicker
                      position={'bottom-start'}
                      disabled={isReadOnly}
                      name="dateTravelCancellation"
                      type="text"
                      onDayChange={this.handleDayChange('form.dateTravelCancellation')}
                      value={dateTravelCancellation}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.dateTripWasCancelledWithTravelSupplier}
                      />
                    </ErrorMessage>
                    <ErrorMessage for="checkDateOnly">
                      <FormattedMessage
                        {...messages.checkEventDate}
                        values={messages.dateTripWasCancelledWithTravelSupplier}
                      />
                    </ErrorMessage>
                  </Validate>
                </div>
                <div className={'col-sm-6 form-group'}>
                </div>
              </div>
            }
            {!newVersion &&
              <div className={'ml-2 row'}>
                <div className={'col-sm-12 form-group'}>
                  <Validate
                    name="reasonForCancellation"
                    validators={[required]}
                    group={this.validatorGroup}
                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                    validationCounter={this.state.validationCounter}
                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                    defaultValue={reasonForTravelCancellation}
                    fieldName={messages.reasonForCancellation}
                  >
                    <TextArea
                      name="reasonForAirlineReissue"
                      type="text"
                      onChange={this.handleChange('form.reasonForTravelCancellation')}
                      value={reasonForTravelCancellation}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.reasonForCancellation}
                      />
                    </ErrorMessage>
                  </Validate>
                </div>
              </div>
            }
            {!newVersion &&
              <div>
                <div className={'ml-2 row'}>
                  <div className={'col-sm-5 form-group'}>
                    <PageSectionHeader>
                      <FormattedMessage {...messages.nameOfPersonHavingSickness} />
                    </PageSectionHeader>
                    <Textbox
                      name="nameOfPersonHavingSicknessTravelCancellation"
                      type="text"
                      onChange={this.handleChange('form.nameOfPersonHavingSicknessTravelCancellation')}
                      value={nameOfPersonHavingSicknessTravelCancellation}
                      disabled={isReadOnly}
                    />
                  </div>
                  <div className={'col-sm-3 form-group'}>
                    <PageSectionHeader>
                      <FormattedMessage {...messages.dateOfBirth} />
                    </PageSectionHeader>
                    <DatePicker
                      position={'bottom-start'}
                      disabled={isReadOnly}
                      name="dateOfBirthTravelCancellation"
                      type="text"
                      onDayChange={this.handleDayChange('form.dateOfBirthTravelCancellation')}
                      value={dateOfBirthTravelCancellation}
                    />
                  </div>
                  <div className={'col-sm-4 form-group'}>
                    <PageSectionHeader>
                      <FormattedMessage {...messages.relationshipToClaimant} />
                    </PageSectionHeader>
                    <Textbox
                      name="relationshipToClaimantTravelCancellation"
                      type="text"
                      onChange={this.handleChange('form.relationshipToClaimantTravelCancellation')}
                      value={relationshipToClaimantTravelCancellation}
                      disabled={isReadOnly}
                    />
                  </div>
                </div>
                <div className={'ml-2 row'}>
                  <div className={'col-sm-4 form-group'}>
                    <PageSectionHeader>
                      <FormattedMessage {...messages.dateSicknessOrInjuryBegan} />
                    </PageSectionHeader>
                    <DatePicker
                      position={'bottom-start'}
                      disabled={isReadOnly}
                      name="dateSicknessOrInjuryBeganTravelCancellation"
                      type="text"
                      onDayChange={this.handleDayChange('form.dateSicknessOrInjuryBeganTravelCancellation')}
                      value={dateSicknessOrInjuryBeganTravelCancellation}
                    />
                  </div>
                  <div className={'col-sm-4 form-group'}>
                    <PageSectionHeader>
                      <FormattedMessage {...messages.dateEnded} />
                    </PageSectionHeader>
                    <DatePicker
                      position={'bottom-start'}
                      disabled={isReadOnly}
                      name="dateEndedTravelCancellation"
                      type="text"
                      onDayChange={this.handleDayChange('form.dateEndedTravelCancellation')}
                      value={dateEndedTravelCancellation}
                    />
                  </div>
                  <div className={'col-sm-4 form-group'}>
                  </div>
                </div>
                <div className={'ml-2 row'}>
                  <div className={'col-sm-12 form-group'}>
                    <PageSectionHeader>
                      <FormattedMessage {...messages.natureOfSicknessOrInjury} />
                    </PageSectionHeader>
                    <TextArea
                      disabled={isReadOnly}
                      name="natureOfSicknessOrInjuryTravelCancellation"
                      type="text"
                      onChange={this.handleChange('form.natureOfSicknessOrInjuryTravelCancellation')}
                      value={natureOfSicknessOrInjuryTravelCancellation}
                      isSummary={isSummary}
                    />
                  </div>
                </div>
                <div className={'ml-2 row'}>
                  <div className={'col-sm-12 form-group'}>
                    <PageSectionHeader>
                      <FormattedMessage {...messages.periodOfHospitalization} />
                    </PageSectionHeader>
                  </div>
                  <div className={'form-group col-sm-3'}>
                    <PageSectionHeader>
                      <FormattedMessage {...messages.fromDate} />
                    </PageSectionHeader>
                    <DatePicker
                      position={'bottom-start'}
                      disabled={isReadOnly}
                      name="fromDateTravelCancellation"
                      type="text"
                      onDayChange={this.handleDayChange('form.fromDateTravelCancellation')}
                      value={fromDateTravelCancellation}
                    />
                  </div>
                  <div className={'form-group col-sm-3'}>
                    <PageSectionHeader>
                      <FormattedMessage {...messages.toDate} />
                    </PageSectionHeader>
                    <DatePicker
                      position={'bottom-start'}
                      disabled={isReadOnly}
                      name="toDateTravelCancellation"
                      type="text"
                      onDayChange={this.handleDayChange('form.toDateTravelCancellation')}
                      value={toDateTravelCancellation}
                    />
                  </div>
                  <div className={'form-group col-sm-6'}>
                  </div>
                </div>
                <div className={'ml-2 row'}>
                  <div className={'form-group col-sm-7'}>
                    <HelpText>
                      On clicking the button an email with the Statement of Attending Physician will be sent to you. Once sent please check your email.
                    </HelpText>
                  </div>
                  <div className={'form-group col-sm-5'}>
                    <AsyncButtonSendMail
                      id={this.emailMeDocumentButton}
                      className={buttonEmailMeDisable ? 'btn-action-success' : 'btn-authentication'}
                      disabled={buttonEmailMeDisable || isReadOnly}
                      loading={this.props.loading}
                      spinner={this.showSpinnerForElement(this.emailMeDocumentButton)}
                      onClick={this.handleEmailMeButtonClick}
                    >
                      Statement of Attending Physician
                    </AsyncButtonSendMail>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      )
    );
  }

  // Trip Cancellation for Any Reason
  renderTripCancellationForAnyReason() {
    const {
      tripCancellationForAnyReason,
      areYouCancellingTheTripDueToMedicalReasonsForAnyReason,
      dateTripCancellationForAnyReason,
      reasonForTripCancellationForAnyReason,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted, jsonVersion, isClaimGroupAllowed } = this.props;
    const isReadOnly = submitted || isSummary;
    const newVersion = jsonVersion > 7;
    return (
      tripCancellationForAnyReason === 'true' && (
        <div>
          {!newVersion &&
            <div className={'ml-3 row'}>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.areYouCancellingTheTripDueToMedicalReasons} />
                </PageSectionHeader>
                <FlexBox>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="true"
                      checked={areYouCancellingTheTripDueToMedicalReasonsForAnyReason === 'true'}
                      onChange={this.handleChange('form.areYouCancellingTheTripDueToMedicalReasonsForAnyReason')}
                    />
                    <FormattedMessage {...messages.yes} />
                  </OptionsContainer>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="false"
                      checked={areYouCancellingTheTripDueToMedicalReasonsForAnyReason === 'false'}
                      onChange={this.handleChange('form.areYouCancellingTheTripDueToMedicalReasonsForAnyReason')}
                    />
                    <FormattedMessage {...messages.no} />
                  </OptionsContainer>
                </FlexBox>
              </div>
            </div>
          }
          {!newVersion &&
            <div className={'ml-3'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.insureds} />
              </PageSectionHeader>
              {this.renderInsuredsTripCancellationForAnyReason()}
            </div>
          }
          {newVersion &&
            <div className={'ml-3'}>
              <div className={'row'}>
                <div className={'col-sm-6 form-group'}>
                  <Validate
                    name="dateTripCancellationForAnyReason"
                    validators={[checkDateOnly, required]}
                    group={this.validatorGroup}
                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                    validationCounter={this.state.validationCounter}
                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                    defaultValue={dateTripCancellationForAnyReason}
                    fieldName={messages.dateTripWasCancelledWithTravelSupplier}
                  >
                    <DatePicker
                      position={'bottom-start'}
                      disabled={isReadOnly}
                      name="dateTripCancellationForAnyReason"
                      type="text"
                      onDayChange={this.handleDayChange('form.dateTripCancellationForAnyReason')}
                      value={dateTripCancellationForAnyReason}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.dateTripWasCancelledWithTravelSupplier}
                      />
                    </ErrorMessage>
                    <ErrorMessage for="checkDateOnly">
                      <FormattedMessage
                        {...messages.checkEventDate}
                        values={messages.dateTripWasCancelledWithTravelSupplier}
                      />
                    </ErrorMessage>
                  </Validate>
                </div>
                <div className={'col-sm-6 form-group'}>
                </div>
              </div>
              <div className={'row'}>
                <div className={'col-sm-12 form-group'}>
                  <Validate
                    name="reasonForCancellation"
                    validators={[required]}
                    group={this.validatorGroup}
                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                    validationCounter={this.state.validationCounter}
                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                    defaultValue={reasonForTripCancellationForAnyReason}
                    fieldName={messages.reasonForCancellation}
                  >
                    <TextArea
                      name="reasonForAirlineReissue"
                      type="text"
                      onChange={this.handleChange('form.reasonForTripCancellationForAnyReason')}
                      value={reasonForTripCancellationForAnyReason}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.reasonForCancellation}
                      />
                    </ErrorMessage>
                  </Validate>
                </div>
              </div>
            </div>
          }
          {isClaimGroupAllowed &&
            <div className={'ml-3 row'}>
              <div className={'col-sm-12'}>
                <HelpText>
                  The amount you claim below is PER MEMBER. It needs to be an EQUAL amount claimed, for each person you selected in the page “What Happened”.
                  If you want to claim DIFFERENT amounts for each person, please create a SEPARATE CLAIM per person.
                </HelpText>
              </div>
            </div>}
          <div className={'ml-3 mt-3'}>
            <PageSectionHeader>
              <FormattedMessage
                {...(isClaimGroupAllowed ? messages.lossInformationPerPerson : messages.lossInformation)}
              />
            </PageSectionHeader>
            {this.renderForAnyReasonInformationItems()}
            {!newVersion &&
              <div className={'ml-2'}>
                <div className={'row'}>
                  <div className={'col-sm-6 form-group'}>
                    <Validate
                      name="dateTripCancellationForAnyReason"
                      validators={[checkDateOnly, required]}
                      group={this.validatorGroup}
                      addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                      validChangeInGroup={this.validatorGroup.validChangeInGroup}
                      validationCounter={this.state.validationCounter}
                      validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                      defaultValue={dateTripCancellationForAnyReason}
                      fieldName={messages.dateTripWasCancelledWithTravelSupplier}
                    >
                      <DatePicker
                        position={'bottom-start'}
                        disabled={isReadOnly}
                        name="dateTripCancellationForAnyReason"
                        type="text"
                        onDayChange={this.handleDayChange('form.dateTripCancellationForAnyReason')}
                        value={dateTripCancellationForAnyReason}
                      />
                      <ErrorMessage for="required">
                        <FormattedMessage
                          {...messages.isRequired}
                          values={messages.dateTripWasCancelledWithTravelSupplier}
                        />
                      </ErrorMessage>
                      <ErrorMessage for="checkDateOnly">
                        <FormattedMessage
                          {...messages.checkEventDate}
                          values={messages.dateTripWasCancelledWithTravelSupplier}
                        />
                      </ErrorMessage>
                    </Validate>
                  </div>
                  <div className={'col-sm-6 form-group'}>
                  </div>
                </div>
                <div className={'row'}>
                  <div className={'col-sm-12 form-group'}>
                    <Validate
                      name="reasonForCancellation"
                      validators={[required]}
                      group={this.validatorGroup}
                      addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                      validChangeInGroup={this.validatorGroup.validChangeInGroup}
                      validationCounter={this.state.validationCounter}
                      validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                      defaultValue={reasonForTripCancellationForAnyReason}
                      fieldName={messages.reasonForCancellation}
                    >
                      <TextArea
                        name="reasonForAirlineReissue"
                        type="text"
                        onChange={this.handleChange('form.reasonForTripCancellationForAnyReason')}
                        value={reasonForTripCancellationForAnyReason}
                        disabled={isReadOnly}
                      />
                      <ErrorMessage for="required">
                        <FormattedMessage
                          {...messages.isRequired}
                          values={messages.reasonForCancellation}
                        />
                      </ErrorMessage>
                    </Validate>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      )
    );
  }

  // Travel Delay
  renderTravelDelay() {
    const {
      travelDelay,
      reasonsForDelay,
      flightNumberTravelDelay,
      flightDateTravelDelay,
      flightDetailsTravelDelay = {},
      typeOfTransportTravelDelay,
      cruiseLineDetailsTravelDelay,
      otherDetailsTravelDelay,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted, jsonVersion, isClaimGroupAllowed } = this.props;
    const reasonsForDelays = !!reasonsForDelay && typeof reasonsForDelay.toJS === 'function'
      ? reasonsForDelay.toJS()
      : reasonsForDelay || [];
    const isReadOnly = submitted || isSummary;
    const isOnlyOne = reasonsForDelays.length > 0;
    const isReasonWeatherRelated = reasonsForDelays.includes('Reasons1');
    const isFlightNumberValid = checkFlightNumberOnly(flightNumberTravelDelay);
    const isFlightDateValid = checkFlightDateOnly(flightDateTravelDelay);
    const flights = flightDetailsTravelDelay.flights || [];
    const flightDetail = flights.length === 1 ? flights[0] : flights[flightDetailsTravelDelay.selectedFlightIndex];
    const showSectionFlightDetails = flightDetailsTravelDelay && (flightDetailsTravelDelay.onSuccessFlighAPIRequest || flightDetailsTravelDelay.callFailFlighAPIRequest);
    const isDisable = isReadOnly || (flightDetailsTravelDelay && (flightDetailsTravelDelay.onSuccessFlighAPIRequest || !flightDetailsTravelDelay.manuallyEnterFlight));
    return (
      travelDelay === 'true' && (
        <div>
          <div className={'ml-3'}>
            <div className={'col-sm-12 form-group'}>
              <Validate
                name="reasonsForDelay"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={reasonsForDelays}
                fieldName={messages.reasonsForDelay}
              >
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={(isReadOnly || isOnlyOne) && !reasonsForDelays.includes('Reasons1')}
                    type="checkbox"
                    name="Reasons1"
                    checked={reasonsForDelays.includes('Reasons1')}
                    onChange={this.handleReasonsForDelay('form.reasonsForDelay')}
                  />
                  <span>
                    <FormattedMessage {...messages.reasons1ForTravelDelay} />
                  </span>
                  {isReasonWeatherRelated === true &&
                    <div>
                      <div className={'pt-2'} style={{ fontWeight: 'bold' }}>
                        <FormattedMessage {...messages.typeOfTransport} />
                      </div>
                      <div className={'ml-2 row pt-2'}>
                        <div className={'col-sm-12 form-group'}>
                          <FlexBox>
                            <OptionsContainer>
                              <input
                                disabled={isReadOnly}
                                type="radio"
                                value="airline"
                                checked={typeOfTransportTravelDelay === 'airline'}
                                onChange={this.handleChangeTypeOfTransport('form.typeOfTransportTravelDelay')}
                              />
                              <FormattedMessage {...messages.airline} />
                            </OptionsContainer>
                            <OptionsContainer>
                              <input
                                disabled={isReadOnly}
                                type="radio"
                                value="cruiseLine"
                                checked={typeOfTransportTravelDelay === 'cruiseLine'}
                                onChange={this.handleChangeTypeOfTransport('form.typeOfTransportTravelDelay')}
                              />
                              <FormattedMessage {...messages.cruiseLine} />
                            </OptionsContainer>
                            <OptionsContainer>
                              <input
                                disabled={isReadOnly}
                                type="radio"
                                value="other"
                                checked={typeOfTransportTravelDelay === 'other'}
                                onChange={this.handleChangeTypeOfTransport('form.typeOfTransportTravelDelay')}
                              />
                              <FormattedMessage {...messages.other} />
                            </OptionsContainer>
                          </FlexBox>
                        </div>
                      </div>
                      {typeOfTransportTravelDelay === 'airline' &&
                        <div className={'ml-2'}>
                          <PageSectionHeader>
                            <FormattedMessage {...messages.pleaseEnterYourFlightNumberAndDateBelow} />
                          </PageSectionHeader>
                          <div className={'row'}>
                            <div className={'col-sm-4 form-group'}>
                              <Validate
                                name="flightNumber"
                                validators={[checkFlightNumberOnly, required]}
                                group={this.validatorGroup}
                                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                                validationCounter={this.state.validationCounter}
                                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                                defaultValue={flightNumberTravelDelay}
                                fieldName={messages.flightNumber}
                              >
                                <Textbox
                                  name="flightNumber"
                                  type="text"
                                  onChange={this.handleChange('form.flightNumberTravelDelay')}
                                  value={flightNumberTravelDelay}
                                  disabled={isReadOnly}
                                />
                                <ErrorMessage for="required">
                                  <FormattedMessage
                                    {...messages.isRequired}
                                    values={messages.flightNumber}
                                  />
                                </ErrorMessage>
                                <ErrorMessage for="checkFlightNumberOnly">
                                  <FormattedMessage
                                    {...messages.checkFlightNumber}
                                    values={messages.flightNumber}
                                  />
                                </ErrorMessage>
                              </Validate>
                            </div>
                            <div className={'col-sm-4 form-group'}>
                              <Validate
                                name="flightDate"
                                validators={[checkFlightDateOnly, required]}
                                group={this.validatorGroup}
                                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                                validationCounter={this.state.validationCounter}
                                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                                defaultValue={flightDateTravelDelay}
                                fieldName={messages.flightDate}
                              >
                                <FlightDatePicker
                                  position={'bottom-start'}
                                  disabled={isReadOnly}
                                  name="flightDate"
                                  type="text"
                                  onDayChange={this.handleDayChange('form.flightDateTravelDelay')}
                                  value={flightDateTravelDelay}
                                />
                                <ErrorMessage for="required">
                                  <FormattedMessage
                                    {...messages.isRequired}
                                    values={messages.flightDate}
                                  />
                                </ErrorMessage>
                                <ErrorMessage for="checkFlightDateOnly">
                                  <FormattedMessage
                                    {...messages.checkFlightDate}
                                    values={messages.flightDate}
                                  />
                                </ErrorMessage>
                              </Validate>
                            </div>
                            <div className={'col-sm-2 form-group'}></div>
                          </div>
                          <div className={'row'}>
                            <div className={'col-sm-12 form-group'}>
                              <AsyncButton
                                id="searchFlightButton"
                                className={'btn-authentication'}
                                disabled={isReadOnly || (!isFlightNumberValid && !isFlightDateValid)}
                                loading={this.props.loading}
                                spinner={this.showSpinnerForElement('searchFlightButton')}
                                onClick={this.flightVerificationTravelDelay('flightDetailsTravelDelay')}
                              >
                                Search Flight
                              </AsyncButton>
                            </div>
                          </div>
                          {flightDetailsTravelDelay.onPendingFlighAPIRequest && (
                            <div className={'ml-2 row'}>
                              <div style={{ fontWeight: 'bold' }}>
                                <FormattedMessage {...messages.pendingFlightApiRequest} />
                              </div>
                            </div>
                          )}
                          {flightDetailsTravelDelay.callFailFlighAPIRequest && flightDetailsTravelDelay && flightDetailsTravelDelay.error && (
                            <div className={'row'}>
                              <div className={'col-sm-12'} style={{ color: 'red' }}>
                                {flightDetailsTravelDelay.error}
                              </div>
                            </div>
                          )}
                          {flightDetailsTravelDelay.callFailFlighAPIRequest && flightDetail && (
                            <div className={'row'}>
                              <div className={'form-group col-md-6'}>
                                <OptionsContainer>
                                  <input
                                    disabled={isReadOnly}
                                    type="checkbox"
                                    name="signature"
                                    checked={flightDetailsTravelDelay.manuallyEnterFlight === true}
                                    onChange={this.handleChange('form.flightDetailsTravelDelay.manuallyEnterFlight')}
                                  />
                                  <span>
                                    <FormattedMessage {...messages.manuallyEnterFlight} />
                                  </span>
                                </OptionsContainer>
                              </div>
                              <div className={'form-group col-md-6'}>
                              </div>
                            </div>
                          )}
                          {(flightDetailsTravelDelay.onSuccessFlighAPIRequest && flights.length > 1) && (
                            <div className="row">
                              <div className="col-sm-12">
                                <PageSectionHeader>
                                  <FormattedMessage {...messages.pleaseSelectYourFlightBelow} />
                                </PageSectionHeader>
                                <div className="table-responsive">
                                  <table className="table table-striped">
                                    <thead>
                                      <tr>
                                        <th />
                                        <th><FormattedMessage {...messages.originAirport} /></th>
                                        <th><FormattedMessage {...messages.destinationAirport} /></th>
                                        <th><FormattedMessage {...messages.scheduledDeparture} /></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {flights.map((flight, index) => (
                                        <tr key={index}>
                                          <td>
                                            <input
                                              type="radio"
                                              name="selectedFlight"
                                              value={index}
                                              checked={flightDetailsTravelDelay.selectedFlightIndex === index}
                                              onChange={() => this.handleFlightSelection('form.flightDetailsTravelDelay.selectedFlightIndex', index)}
                                              disabled={isReadOnly}
                                            />
                                          </td>
                                          <td>{flight.originAirport}</td>
                                          <td>{flight.destinationAirport}</td>
                                          <td>{flight.flightDate}</td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          )}
                          {(showSectionFlightDetails && flightDetail) && (
                            <div className={'row'}>
                              <div className={'col-sm-12'}>
                                <Section>
                                  <ControlContainer>
                                    <div className={'row'}>
                                      <div className={'col-sm-2'}>
                                      </div>
                                      <div className={'col-sm-3'}>
                                        <h4>
                                          <FormattedMessage {...messages.flightDetails} />
                                        </h4>
                                      </div>
                                      <div className={'col-sm-3'}>
                                        <strong>
                                          <FormattedMessage {...messages.searchSuccess} />:
                                        </strong>{' '}
                                        {flightDetailsTravelDelay.success ? 'Yes' : 'No'}
                                      </div>
                                      <div className={'col-sm-2'}>
                                      </div>
                                    </div>
                                    <div className={'row'}>
                                      <div className={'col-sm-6 form-group'}>
                                        <PageSectionHeader>
                                          <FormattedMessage {...messages.flightNumber} />
                                        </PageSectionHeader>
                                        <Textbox
                                          name="flightNumber"
                                          type="text"
                                          onChange={this.handleChangeFlightDetail('flightDetailsTravelDelay', 'flightNumber')}
                                          value={flightDetail.flightNumber}
                                          disabled={isDisable}
                                        />
                                      </div>
                                      <div className={'col-sm-6 form-group'}>
                                        <PageSectionHeader>
                                          <FormattedMessage {...messages.flightDate} />
                                        </PageSectionHeader>
                                        <DatePicker
                                          name="flightDate"
                                          type="text"
                                          onDayChange={this.handleChangeFlightDetail('flightDetailsTravelDelay', 'flightDate')}
                                          value={flightDetail.flightDate}
                                          disabled={isDisable}
                                        />
                                      </div>
                                    </div>
                                    <div className={'row'}>
                                      <div className={'col-sm-12 form-group'}>
                                        <PageSectionHeader>
                                          <FormattedMessage {...messages.airline} />
                                        </PageSectionHeader>
                                        <Textbox
                                          name="airline"
                                          type="text"
                                          onChange={this.handleChangeFlightDetail('flightDetailsTravelDelay', 'airline')}
                                          value={flightDetail.airline}
                                          disabled={isDisable}
                                        />
                                      </div>
                                    </div>
                                    <div className={'row'}>
                                      <div className={'col-sm-6 form-group'}>
                                        <PageSectionHeader>
                                          <FormattedMessage {...messages.originAirport} />
                                        </PageSectionHeader>
                                        <Textbox
                                          name="originAirport"
                                          type="text"
                                          onChange={this.handleChangeFlightDetail('flightDetailsTravelDelay', 'originAirport')}
                                          value={flightDetail.originAirport}
                                          disabled={isDisable}
                                        />
                                      </div>
                                      <div className={'col-sm-6 form-group'}>
                                        <PageSectionHeader>
                                          <FormattedMessage {...messages.destinationAirport} />
                                        </PageSectionHeader>
                                        <Textbox
                                          name="destinationAirport"
                                          type="text"
                                          onChange={this.handleChangeFlightDetail('flightDetailsTravelDelay', 'destinationAirport')}
                                          value={flightDetail.destinationAirport}
                                          disabled={isDisable}
                                        />
                                      </div>
                                    </div>
                                    {!isDisable && (
                                      <div className={'row'}>
                                        <div className={'col-sm-6 form-group'}>
                                          <PageSectionHeader>
                                            <FormattedMessage {...messages.scheduledOut} />
                                          </PageSectionHeader>
                                          <DatePicker
                                            name="scheduledOut"
                                            type="text"
                                            onDayChange={this.handleChangeFlightDetail('flightDetailsTravelDelay', 'scheduledOut')}
                                            value={flightDetail.scheduledOut}
                                            disabled={isDisable}
                                          />
                                        </div>
                                        <div className={'col-sm-6 form-group'}>
                                          <PageSectionHeader>
                                            <FormattedMessage {...messages.scheduledIn} />
                                          </PageSectionHeader>
                                          <DatePicker
                                            name="scheduledIn"
                                            type="text"
                                            onDayChange={this.handleChangeFlightDetail('flightDetailsTravelDelay', 'scheduledIn')}
                                            value={flightDetail.scheduledIn}
                                            disabled={isDisable}
                                          />
                                        </div>
                                      </div>
                                    )}
                                    {isDisable && (
                                      <div className={'row'}>
                                        <div className={'col-sm-6 form-group'}>
                                          <PageSectionHeader>
                                            <FormattedMessage {...messages.scheduledOut} />
                                          </PageSectionHeader>
                                          <Textbox
                                            name="scheduledOut"
                                            type="text"
                                            onDayChange={this.handleChangeFlightDetail('flightDetailsTravelDelay', 'scheduledOut')}
                                            value={flightDetail.scheduledOut}
                                            disabled={isDisable}
                                          />
                                        </div>
                                        <div className={'col-sm-6 form-group'}>
                                          <PageSectionHeader>
                                            <FormattedMessage {...messages.scheduledIn} />
                                          </PageSectionHeader>
                                          <Textbox
                                            name="scheduledIn"
                                            type="text"
                                            onDayChange={this.handleChangeFlightDetail('flightDetailsTravelDelay', 'scheduledIn')}
                                            value={flightDetail.scheduledIn}
                                            disabled={isDisable}
                                          />
                                        </div>
                                      </div>
                                    )}
                                    <div className={'row'}>
                                      <div className={'col-sm-3 form-group'}>
                                        <PageSectionHeader>
                                          <FormattedMessage {...messages.departureDelay} />
                                        </PageSectionHeader>
                                        <Textbox
                                          name="departureDelay"
                                          type="number"
                                          onChange={this.handleChangeFlightDetail('flightDetailsTravelDelay', 'departureDelay')}
                                          value={flightDetail.departureDelay}
                                          disabled={isDisable}
                                        />
                                      </div>
                                      <div className={'col-sm-3 form-group'}>
                                        <PageSectionHeader>
                                          <FormattedMessage {...messages.arrivalDelay} />
                                        </PageSectionHeader>
                                        <Textbox
                                          name="arrivalDelay"
                                          type="number"
                                          onChange={this.handleChangeFlightDetail('flightDetailsTravelDelay', 'arrivalDelay')}
                                          value={flightDetail.arrivalDelay}
                                          disabled={isDisable}
                                        />
                                      </div>
                                      <div className={'col-sm-6 form-group'}>
                                        <PageSectionHeader>
                                          <FormattedMessage {...messages.cancelled} />
                                        </PageSectionHeader>
                                        <select
                                          name="cancelled"
                                          className="form-control"
                                          onChange={this.handleChangeFlightDetail('flightDetailsTravelDelay', 'cancelled')}
                                          value={flightDetail.cancelled || ''}
                                          disabled={isDisable}
                                        >
                                          <option value="">Select status</option>
                                          <option value="Yes">Yes</option>
                                          <option value="No">No</option>
                                        </select>
                                      </div>
                                    </div>
                                  </ControlContainer>
                                </Section>
                              </div>
                            </div>
                          )}
                        </div>
                      }
                      {typeOfTransportTravelDelay === 'cruiseLine' &&
                        <div className={'ml-2'}>
                          <div className={'row'}>
                            <div className={'col-sm-6 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.cruiseLine} />
                              </PageSectionHeader>
                              <Textbox
                                name="cruiseLine"
                                type="text"
                                onChange={this.handleChange('form.cruiseLineDetailsTravelDelay.cruiseLine')}
                                value={cruiseLineDetailsTravelDelay.cruiseLine}
                                disabled={isReadOnly}
                              />
                            </div>
                            <div className={'col-sm-6 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.cruiseNumber} />
                              </PageSectionHeader>
                              <Textbox
                                name="cruiseNumber"
                                type="text"
                                onChange={this.handleChange('form.cruiseLineDetailsTravelDelay.cruiseNumber')}
                                value={cruiseLineDetailsTravelDelay.cruiseNumber}
                                disabled={isReadOnly}
                              />
                            </div>
                          </div>
                          <div className={'row'}>
                            <div className={'col-sm-6 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.departureDate} />
                              </PageSectionHeader>
                              <DatePicker
                                name="departureDate"
                                type="text"
                                onDayChange={this.handleDayChange('form.cruiseLineDetailsTravelDelay.departureDate')}
                                value={cruiseLineDetailsTravelDelay.departureDate}
                                disabled={isReadOnly}
                              />
                            </div>
                            <div className={'col-sm-6 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.arrivalDate} />
                              </PageSectionHeader>
                              <DatePicker
                                name="arrivalDate"
                                type="text"
                                onDayChange={this.handleDayChange('form.cruiseLineDetailsTravelDelay.arrivalDate')}
                                value={cruiseLineDetailsTravelDelay.arrivalDate}
                                disabled={isReadOnly}
                              />
                            </div>
                          </div>
                          <div className={'row'}>
                            <div className={'col-sm-6 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.departurePort} />
                              </PageSectionHeader>
                              <Textbox
                                name="departurePort"
                                type="text"
                                onChange={this.handleChange('form.cruiseLineDetailsTravelDelay.departurePort')}
                                value={cruiseLineDetailsTravelDelay.departurePort}
                                disabled={isReadOnly}
                              />
                            </div>
                            <div className={'col-sm-6 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.arrivalPort} />
                              </PageSectionHeader>
                              <Textbox
                                name="arrivalPort"
                                type="text"
                                onChange={this.handleChange('form.cruiseLineDetailsTravelDelay.arrivalPort')}
                                value={cruiseLineDetailsTravelDelay.arrivalPort}
                                disabled={isReadOnly}
                              />
                            </div>
                          </div>
                        </div>
                      }
                      {typeOfTransportTravelDelay === 'other' &&
                        <div className={'ml-2'}>
                          <div className={'row'}>
                            <div className={'col-sm-12 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.pleaseDescribeDetailsOfYourJourneyAndWhatWasCancelled} />
                              </PageSectionHeader>
                              <TextArea
                                name="pleaseDescribeDetailsOfYourJourneyAndWhatWasCancelled"
                                type="text"
                                onChange={this.handleChange('form.otherDetailsTravelDelay.pleaseDescribeDetailsOfYourJourneyAndWhatWasCancelled')}
                                value={otherDetailsTravelDelay.pleaseDescribeDetailsOfYourJourneyAndWhatWasCancelled}
                                disabled={isReadOnly}
                              />
                            </div>
                          </div>
                          <div className={'row'}>
                            <div className={'col-sm-6 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.departureDate} />
                              </PageSectionHeader>
                              <DatePicker
                                name="departureDate"
                                type="text"
                                onDayChange={this.handleDayChange('form.otherDetailsTravelDelay.departureDate')}
                                value={otherDetailsTravelDelay.departureDate}
                                disabled={isReadOnly}
                              />
                            </div>
                          </div>
                          <div className={'row'}>
                            <div className={'col-sm-6 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.departureLocation} />
                              </PageSectionHeader>
                              <Textbox
                                name="departureLocation"
                                type="text"
                                onChange={this.handleChange('form.otherDetailsTravelDelay.departureLocation')}
                                value={otherDetailsTravelDelay.departureLocation}
                                disabled={isReadOnly}
                              />
                            </div>
                            <div className={'col-sm-6 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.destination} />
                              </PageSectionHeader>
                              <Textbox
                                name="destination"
                                type="text"
                                onChange={this.handleChange('form.otherDetailsTravelDelay.destination')}
                                value={otherDetailsTravelDelay.destination}
                                disabled={isReadOnly}
                              />
                            </div>
                          </div>
                          <div className={'row'}>
                            <div className={'col-sm-6 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.descriptionOfTravelType} />
                              </PageSectionHeader>
                              <Textbox
                                name="descriptionOfTravelType"
                                type="text"
                                onChange={this.handleChange('form.otherDetailsTravelDelay.descriptionOfTravelType')}
                                value={otherDetailsTravelDelay.descriptionOfTravelType}
                                disabled={isReadOnly}
                              />
                            </div>
                            <div className={'col-sm-6 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.descriptionOfEvent} />
                              </PageSectionHeader>
                              <Textbox
                                name="descriptionOfEvent"
                                type="text"
                                onChange={this.handleChange('form.otherDetailsTravelDelay.descriptionOfEvent')}
                                value={otherDetailsTravelDelay.descriptionOfEvent}
                                disabled={isReadOnly}
                              />
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={(isReadOnly || isOnlyOne) && !reasonsForDelays.includes('Reasons2')}
                    type="checkbox"
                    name="Reasons2"
                    checked={reasonsForDelays.includes('Reasons2')}
                    onChange={this.handleReasonsForDelay('form.reasonsForDelay')}
                  />
                  <span>
                    <FormattedMessage {...messages.reasons2ForTravelDelay} />
                  </span>
                </div>
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={(isReadOnly || isOnlyOne) && !reasonsForDelays.includes('Reasons3')}
                    type="checkbox"
                    name="Reasons3"
                    checked={reasonsForDelays.includes('Reasons3')}
                    onChange={this.handleReasonsForDelay('form.reasonsForDelay')}
                  />
                  <span>
                    <FormattedMessage {...messages.reasons3ForTravelDelay} />
                  </span>
                </div>
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={(isReadOnly || isOnlyOne) && !reasonsForDelays.includes('Reasons4')}
                    type="checkbox"
                    name="Reasons4"
                    checked={reasonsForDelays.includes('Reasons4')}
                    onChange={this.handleReasonsForDelay('form.reasonsForDelay')}
                  />
                  <span>
                    <FormattedMessage {...messages.reasons4ForTravelDelay} />
                  </span>
                </div>
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.reasonsForDelay}
                  />
                </ErrorMessage>
              </Validate>
            </div>
          </div>
          {isClaimGroupAllowed &&
            <div className={'ml-3 row'}>
              <div className={'col-sm-12'}>
                <HelpText>
                  The amount you claim below is PER MEMBER. It needs to be an EQUAL amount claimed, for each person you selected in the page “What Happened”.
                  If you want to claim DIFFERENT amounts for each person, please create a SEPARATE CLAIM per person.
                </HelpText>
              </div>
            </div>
          }
          <div className={'ml-3 mt-3'}>
            <PageSectionHeader>
              <FormattedMessage
                {...(isClaimGroupAllowed ? messages.lossInformationPerPerson : messages.lossInformation)}
              />
            </PageSectionHeader>
            {this.renderTravelDelayInformationItems()}
          </div>
        </div>
      )
    );
  }

  renderTravelDelayInformationItems() {
    const { delayInformationItems } = this.props.form;
    const newDelayInformationItems = this.appendIds(delayInformationItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newDelayInformationItems}
          onChange={this.onDelayInformationItemsChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  // Missed Connection
  renderMissedConnection() {
    const {
      missedConnection,
      reasonsForMissedConnection,
      flightNumberMissedConnection,
      flightDateMissedConnection,
      flightDetailsMissedConnection,
      typeOfTransportMissedConnection,
      cruiseLineDetailsMissedConnection,
      otherDetailsMissedConnection,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted, isClaimGroupAllowed } = this.props;
    const reasonsForMissedConnections = !!reasonsForMissedConnection && typeof reasonsForMissedConnection.toJS === 'function'
      ? reasonsForMissedConnection.toJS()
      : reasonsForMissedConnection || [];
    const isOnlyOne = reasonsForMissedConnections.length > 0;
    const isReadOnly = submitted || isSummary;
    // const isReasonWeatherRelated = reasonsForMissedConnections.includes('Reasons1');
    // const isFlightNumberValid = checkFlightNumberOnly(flightNumberMissedConnection);
    // const isFlightDateValid = checkFlightDateOnly(flightDateMissedConnection);
    // const flights = flightDetailsMissedConnection.flights || [];
    // const flightDetail = flights.length === 1 ? flights[0] : flights[flightDetailsMissedConnection.selectedFlightIndex];
    // const showSectionFlightDetails = flightDetailsMissedConnection.onSuccessFlighAPIRequest || flightDetailsMissedConnection.callFailFlighAPIRequest;
    // const isDisable = isReadOnly || flightDetailsMissedConnection.onSuccessFlighAPIRequest || !flightDetailsMissedConnection.manuallyEnterFlight;
    return (
      missedConnection === 'true' && (
        <div>
          <div className={'ml-3'}>
            <div className={'col-sm-12 form-group'}>
              <Validate
                name="reasonsForDelay"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={reasonsForMissedConnections}
                fieldName={messages.reasonsForMissedConnection}
              >
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={(isReadOnly || isOnlyOne) && !reasonsForMissedConnections.includes('Reasons1')}
                    type="checkbox"
                    name="Reasons1"
                    checked={reasonsForMissedConnections.includes('Reasons1')}
                    onChange={this.handleReasonsForMissedConnection('form.reasonsForMissedConnection')}
                  />
                  <span>
                    <FormattedMessage {...messages.reasons1ForTravelDelay} />
                  </span>
                  {/* {isReasonWeatherRelated === true &&
                    <div>
                      <div className={'pt-2'} style={{ fontWeight: 'bold' }}>
                        <FormattedMessage {...messages.typeOfTransport} />
                      </div>
                      <div className={'ml-2 row pt-2'}>
                        <div className={'col-sm-12 form-group'}>
                          <FlexBox>
                            <OptionsContainer>
                              <input
                                disabled={isReadOnly}
                                type="radio"
                                value="airline"
                                checked={typeOfTransportMissedConnection === 'airline'}
                                onChange={this.handleChangeTypeOfTransport('form.typeOfTransportMissedConnection')}
                              />
                              <FormattedMessage {...messages.airline} />
                            </OptionsContainer>
                            <OptionsContainer>
                              <input
                                disabled={isReadOnly}
                                type="radio"
                                value="cruiseLine"
                                checked={typeOfTransportMissedConnection === 'cruiseLine'}
                                onChange={this.handleChangeTypeOfTransport('form.typeOfTransportMissedConnection')}
                              />
                              <FormattedMessage {...messages.cruiseLine} />
                            </OptionsContainer>
                            <OptionsContainer>
                              <input
                                disabled={isReadOnly}
                                type="radio"
                                value="other"
                                checked={typeOfTransportMissedConnection === 'other'}
                                onChange={this.handleChangeTypeOfTransport('form.typeOfTransportMissedConnection')}
                              />
                              <FormattedMessage {...messages.other} />
                            </OptionsContainer>
                          </FlexBox>
                        </div>
                      </div>
                      {typeOfTransportMissedConnection === 'airline' &&
                        <div className={'ml-2'}>
                          <PageSectionHeader>
                            <FormattedMessage {...messages.pleaseEnterYourFlightNumberAndDateBelow} />
                          </PageSectionHeader>
                          <div className={'row'}>
                            <div className={'col-sm-4 form-group'}>
                              <Validate
                                name="flightNumber"
                                validators={[checkFlightNumberOnly, required]}
                                group={this.validatorGroup}
                                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                                validationCounter={this.state.validationCounter}
                                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                                defaultValue={flightNumberMissedConnection}
                                fieldName={messages.flightNumber}
                              >
                                <Textbox
                                  name="flightNumber"
                                  type="text"
                                  onChange={this.handleChange('form.flightNumberMissedConnection')}
                                  value={flightNumberMissedConnection}
                                  disabled={isReadOnly}
                                />
                                <ErrorMessage for="required">
                                  <FormattedMessage
                                    {...messages.isRequired}
                                    values={messages.flightNumber}
                                  />
                                </ErrorMessage>
                                <ErrorMessage for="checkFlightNumberOnly">
                                  <FormattedMessage
                                    {...messages.checkFlightNumber}
                                    values={messages.flightNumber}
                                  />
                                </ErrorMessage>
                              </Validate>
                            </div>
                            <div className={'col-sm-4 form-group'}>
                              <Validate
                                name="flightDate"
                                validators={[checkFlightDateOnly, required]}
                                group={this.validatorGroup}
                                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                                validationCounter={this.state.validationCounter}
                                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                                defaultValue={flightDateMissedConnection}
                                fieldName={messages.flightDate}
                              >
                                <FlightDatePicker
                                  position={'bottom-start'}
                                  disabled={isReadOnly}
                                  name="flightDate"
                                  type="text"
                                  onDayChange={this.handleDayChange('form.flightDateMissedConnection')}
                                  value={flightDateMissedConnection}
                                />
                                <ErrorMessage for="required">
                                  <FormattedMessage
                                    {...messages.isRequired}
                                    values={messages.flightDate}
                                  />
                                </ErrorMessage>
                                <ErrorMessage for="checkFlightDateOnly">
                                  <FormattedMessage
                                    {...messages.checkFlightDate}
                                    values={messages.flightDate}
                                  />
                                </ErrorMessage>
                              </Validate>
                            </div>
                            <div className={'col-sm-2 form-group'}></div>
                          </div>
                          <div className={'row'}>
                            <div className={'col-sm-12 form-group'}>
                              <AsyncButton
                                id="searchFlightButton"
                                className={'btn-authentication'}
                                disabled={isReadOnly || (!isFlightNumberValid && !isFlightDateValid)}
                                loading={this.props.loading}
                                spinner={this.showSpinnerForElement('searchFlightButton')}
                                onClick={this.flightVerificationMissedConnection('flightDetailsMissedConnection')}
                              >
                                Search Flight
                              </AsyncButton>
                            </div>
                          </div>
                          {flightDetailsMissedConnection.onPendingFlighAPIRequest && (
                            <div className={'ml-2 row'}>
                              <div style={{ fontWeight: 'bold' }}>
                                <FormattedMessage {...messages.pendingFlightApiRequest} />
                              </div>
                            </div>
                          )}
                          {flightDetailsMissedConnection.callFailFlighAPIRequest && flightDetailsMissedConnection && flightDetailsMissedConnection.error && (
                            <div className={'row'}>
                              <div className={'col-sm-12'} style={{ color: 'red' }}>
                                {flightDetailsMissedConnection.error}
                              </div>
                            </div>
                          )}
                          {flightDetailsMissedConnection.callFailFlighAPIRequest && flightDetail && (
                            <div className={'row'}>
                              <div className={'form-group col-md-6'}>
                                <OptionsContainer>
                                  <input
                                    disabled={isReadOnly}
                                    type="checkbox"
                                    name="signature"
                                    checked={flightDetailsMissedConnection.manuallyEnterFlight === true}
                                    onChange={this.handleChange('form.flightDetailsMissedConnection.manuallyEnterFlight')}
                                  />
                                  <span>
                                    <FormattedMessage {...messages.manuallyEnterFlight} />
                                  </span>
                                </OptionsContainer>
                              </div>
                              <div className={'form-group col-md-6'}>
                              </div>
                            </div>
                          )}
                          {(flightDetailsMissedConnection.onSuccessFlighAPIRequest && flights.length > 1) && (
                            <div className="row">
                              <div className="col-sm-12">
                                <PageSectionHeader>
                                  <FormattedMessage {...messages.pleaseSelectYourFlightBelow} />
                                </PageSectionHeader>
                                <div className="table-responsive">
                                  <table className="table table-striped">
                                    <thead>
                                      <tr>
                                        <th />
                                        <th><FormattedMessage {...messages.originAirport} /></th>
                                        <th><FormattedMessage {...messages.destinationAirport} /></th>
                                        <th><FormattedMessage {...messages.scheduledDeparture} /></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {flights.map((flight, index) => (
                                        <tr key={index}>
                                          <td>
                                            <input
                                              type="radio"
                                              name="selectedFlight"
                                              value={index}
                                              checked={flightDetailsMissedConnection.selectedFlightIndex === index}
                                              onChange={() => this.handleFlightSelection('form.flightDetailsMissedConnection.selectedFlightIndex', index)}
                                              disabled={isReadOnly}
                                            />
                                          </td>
                                          <td>{flight.originAirport}</td>
                                          <td>{flight.destinationAirport}</td>
                                          <td>{flight.flightDate}</td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          )}
                          {(showSectionFlightDetails && flightDetail) && (
                            <div className={'row'}>
                              <div className={'col-sm-12'}>
                                <Section>
                                  <ControlContainer>
                                    <div className={'row'}>
                                      <div className={'col-sm-2'}>
                                      </div>
                                      <div className={'col-sm-3'}>
                                        <h4>
                                          <FormattedMessage {...messages.flightDetails} />
                                        </h4>
                                      </div>
                                      <div className={'col-sm-7'}>
                                        <strong>
                                          <FormattedMessage {...messages.searchSuccess} />:
                                        </strong>{' '}
                                        {flightDetailsMissedConnection.success ? 'Yes' : 'No'}
                                      </div>
                                    </div>
                                    <div className={'row'}>
                                      <div className={'col-sm-6 form-group'}>
                                        <PageSectionHeader>
                                          <FormattedMessage {...messages.flightNumber} />
                                        </PageSectionHeader>
                                        <Textbox
                                          name="flightNumber"
                                          type="text"
                                          onChange={this.handleChangeFlightDetail('flightDetailsMissedConnection', 'flightNumber')}
                                          value={flightDetail.flightNumber}
                                          disabled={isDisable}
                                        />
                                      </div>
                                      <div className={'col-sm-6 form-group'}>
                                        <PageSectionHeader>
                                          <FormattedMessage {...messages.flightDate} />
                                        </PageSectionHeader>
                                        <DatePicker
                                          name="flightDate"
                                          type="text"
                                          onDayChange={this.handleChangeFlightDetail('flightDetailsMissedConnection', 'flightDate')}
                                          value={flightDetail.flightDate}
                                          disabled={isDisable}
                                        />
                                      </div>
                                    </div>
                                    <div className={'row'}>
                                      <div className={'col-sm-12 form-group'}>
                                        <PageSectionHeader>
                                          <FormattedMessage {...messages.airline} />
                                        </PageSectionHeader>
                                        <Textbox
                                          name="airline"
                                          type="text"
                                          onChange={this.handleChangeFlightDetail('flightDetailsMissedConnection', 'airline')}
                                          value={flightDetail.airline}
                                          disabled={isDisable}
                                        />
                                      </div>
                                    </div>
                                    <div className={'row'}>
                                      <div className={'col-sm-6 form-group'}>
                                        <PageSectionHeader>
                                          <FormattedMessage {...messages.originAirport} />
                                        </PageSectionHeader>
                                        <Textbox
                                          name="originAirport"
                                          type="text"
                                          onChange={this.handleChangeFlightDetail('flightDetailsMissedConnection', 'originAirport')}
                                          value={flightDetail.originAirport}
                                          disabled={isDisable}
                                        />
                                      </div>
                                      <div className={'col-sm-6 form-group'}>
                                        <PageSectionHeader>
                                          <FormattedMessage {...messages.destinationAirport} />
                                        </PageSectionHeader>
                                        <Textbox
                                          name="destinationAirport"
                                          type="text"
                                          onChange={this.handleChangeFlightDetail('flightDetailsMissedConnection', 'destinationAirport')}
                                          value={flightDetail.destinationAirport}
                                          disabled={isDisable}
                                        />
                                      </div>
                                    </div>
                                    {!isDisable && (
                                      <div className={'row'}>
                                        <div className={'col-sm-6 form-group'}>
                                          <PageSectionHeader>
                                            <FormattedMessage {...messages.scheduledOut} />
                                          </PageSectionHeader>
                                          <DatePicker
                                            name="scheduledOut"
                                            type="text"
                                            onDayChange={this.handleChangeFlightDetail('flightDetailsMissedConnection', 'scheduledOut')}
                                            value={flightDetail.scheduledOut}
                                            disabled={isDisable}
                                          />
                                        </div>
                                        <div className={'col-sm-6 form-group'}>
                                          <PageSectionHeader>
                                            <FormattedMessage {...messages.scheduledIn} />
                                          </PageSectionHeader>
                                          <DatePicker
                                            name="scheduledIn"
                                            type="text"
                                            onDayChange={this.handleChangeFlightDetail('flightDetailsMissedConnection', 'scheduledIn')}
                                            value={flightDetail.scheduledIn}
                                            disabled={isDisable}
                                          />
                                        </div>
                                      </div>
                                    )}
                                    {isDisable && (
                                      <div className={'row'}>
                                        <div className={'col-sm-6 form-group'}>
                                          <PageSectionHeader>
                                            <FormattedMessage {...messages.scheduledOut} />
                                          </PageSectionHeader>
                                          <Textbox
                                            name="scheduledOut"
                                            type="text"
                                            onDayChange={this.handleChangeFlightDetail('flightDetailsMissedConnection', 'scheduledOut')}
                                            value={flightDetail.scheduledOut}
                                            disabled={isDisable}
                                          />
                                        </div>
                                        <div className={'col-sm-6 form-group'}>
                                          <PageSectionHeader>
                                            <FormattedMessage {...messages.scheduledIn} />
                                          </PageSectionHeader>
                                          <Textbox
                                            name="scheduledIn"
                                            type="text"
                                            onDayChange={this.handleChangeFlightDetail('flightDetailsMissedConnection', 'scheduledIn')}
                                            value={flightDetail.scheduledIn}
                                            disabled={isDisable}
                                          />
                                        </div>
                                      </div>
                                    )}
                                    <div className={'row'}>
                                      <div className={'col-sm-3 form-group'}>
                                        <PageSectionHeader>
                                          <FormattedMessage {...messages.departureDelay} />
                                        </PageSectionHeader>
                                        <Textbox
                                          name="departureDelay"
                                          type="number"
                                          onChange={this.handleChangeFlightDetail('flightDetailsMissedConnection', 'departureDelay')}
                                          value={flightDetail.departureDelay}
                                          disabled={isDisable}
                                        />
                                      </div>
                                      <div className={'col-sm-3 form-group'}>
                                        <PageSectionHeader>
                                          <FormattedMessage {...messages.arrivalDelay} />
                                        </PageSectionHeader>
                                        <Textbox
                                          name="arrivalDelay"
                                          type="number"
                                          onChange={this.handleChangeFlightDetail('flightDetailsMissedConnection', 'arrivalDelay')}
                                          value={flightDetail.arrivalDelay}
                                          disabled={isDisable}
                                        />
                                      </div>
                                      <div className={'col-sm-6 form-group'}>
                                        <PageSectionHeader>
                                          <FormattedMessage {...messages.cancelled} />
                                        </PageSectionHeader>
                                        <select
                                          name="cancelled"
                                          className="form-control"
                                          onChange={this.handleChangeFlightDetail('flightDetailsMissedConnection', 'cancelled')}
                                          value={flightDetail.cancelled || ''}
                                          disabled={isDisable}
                                        >
                                          <option value="">Select status</option>
                                          <option value="Yes">Yes</option>
                                          <option value="No">No</option>
                                        </select>
                                      </div>
                                    </div>
                                  </ControlContainer>
                                </Section>
                              </div>
                            </div>
                          )}
                        </div>
                      }
                      {typeOfTransportMissedConnection === 'cruiseLine' &&
                        <div className={'ml-2'}>
                          <div className={'row'}>
                            <div className={'col-sm-6 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.cruiseLine} />
                              </PageSectionHeader>
                              <Textbox
                                name="cruiseLine"
                                type="text"
                                onChange={this.handleChange('form.cruiseLineDetailsMissedConnection.cruiseLine')}
                                value={cruiseLineDetailsMissedConnection.cruiseLine}
                                disabled={isReadOnly}
                              />
                            </div>
                            <div className={'col-sm-6 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.cruiseNumber} />
                              </PageSectionHeader>
                              <Textbox
                                name="cruiseNumber"
                                type="text"
                                onChange={this.handleChange('form.cruiseLineDetailsMissedConnection.cruiseNumber')}
                                value={cruiseLineDetailsMissedConnection.cruiseNumber}
                                disabled={isReadOnly}
                              />
                            </div>
                          </div>
                          <div className={'row'}>
                            <div className={'col-sm-6 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.departureDate} />
                              </PageSectionHeader>
                              <DatePicker
                                name="departureDate"
                                type="text"
                                onDayChange={this.handleDayChange('form.cruiseLineDetailsMissedConnection.departureDate')}
                                value={cruiseLineDetailsMissedConnection.departureDate}
                                disabled={isReadOnly}
                              />
                            </div>
                            <div className={'col-sm-6 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.arrivalDate} />
                              </PageSectionHeader>
                              <DatePicker
                                name="arrivalDate"
                                type="text"
                                onDayChange={this.handleDayChange('form.cruiseLineDetailsMissedConnection.arrivalDate')}
                                value={cruiseLineDetailsMissedConnection.arrivalDate}
                                disabled={isReadOnly}
                              />
                            </div>
                          </div>
                          <div className={'row'}>
                            <div className={'col-sm-6 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.departurePort} />
                              </PageSectionHeader>
                              <Textbox
                                name="departurePort"
                                type="text"
                                onChange={this.handleChange('form.cruiseLineDetailsMissedConnection.departurePort')}
                                value={cruiseLineDetailsMissedConnection.departurePort}
                                disabled={isReadOnly}
                              />
                            </div>
                            <div className={'col-sm-6 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.arrivalPort} />
                              </PageSectionHeader>
                              <Textbox
                                name="arrivalPort"
                                type="text"
                                onChange={this.handleChange('form.cruiseLineDetailsMissedConnection.arrivalPort')}
                                value={cruiseLineDetailsMissedConnection.arrivalPort}
                                disabled={isReadOnly}
                              />
                            </div>
                          </div>
                        </div>
                      }
                      {typeOfTransportMissedConnection === 'other' &&
                        <div className={'ml-2'}>
                          <div className={'row'}>
                            <div className={'col-sm-12 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.pleaseDescribeDetailsOfYourJourneyAndWhatWasCancelled} />
                              </PageSectionHeader>
                              <TextArea
                                name="pleaseDescribeDetailsOfYourJourneyAndWhatWasCancelled"
                                type="text"
                                onChange={this.handleChange('form.otherDetailsMissedConnection.pleaseDescribeDetailsOfYourJourneyAndWhatWasCancelled')}
                                value={otherDetailsMissedConnection.pleaseDescribeDetailsOfYourJourneyAndWhatWasCancelled}
                                disabled={isReadOnly}
                              />
                            </div>
                          </div>
                          <div className={'row'}>
                            <div className={'col-sm-6 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.departureDate} />
                              </PageSectionHeader>
                              <DatePicker
                                name="departureDate"
                                type="text"
                                onDayChange={this.handleDayChange('form.otherDetailsMissedConnection.departureDate')}
                                value={otherDetailsMissedConnection.departureDate}
                                disabled={isReadOnly}
                              />
                            </div>
                          </div>
                          <div className={'row'}>
                            <div className={'col-sm-6 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.departureLocation} />
                              </PageSectionHeader>
                              <Textbox
                                name="departureLocation"
                                type="text"
                                onChange={this.handleChange('form.otherDetailsMissedConnection.departureLocation')}
                                value={otherDetailsMissedConnection.departureLocation}
                                disabled={isReadOnly}
                              />
                            </div>
                            <div className={'col-sm-6 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.destination} />
                              </PageSectionHeader>
                              <Textbox
                                name="destination"
                                type="text"
                                onChange={this.handleChange('form.otherDetailsMissedConnection.destination')}
                                value={otherDetailsMissedConnection.destination}
                                disabled={isReadOnly}
                              />
                            </div>
                          </div>
                          <div className={'row'}>
                            <div className={'col-sm-6 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.descriptionOfTravelType} />
                              </PageSectionHeader>
                              <Textbox
                                name="descriptionOfTravelType"
                                type="text"
                                onChange={this.handleChange('form.otherDetailsMissedConnection.descriptionOfTravelType')}
                                value={otherDetailsMissedConnection.descriptionOfTravelType}
                                disabled={isReadOnly}
                              />
                            </div>
                            <div className={'col-sm-6 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.descriptionOfEvent} />
                              </PageSectionHeader>
                              <Textbox
                                name="descriptionOfEvent"
                                type="text"
                                onChange={this.handleChange('form.otherDetailsMissedConnection.descriptionOfEvent')}
                                value={otherDetailsMissedConnection.descriptionOfEvent}
                                disabled={isReadOnly}
                              />
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  } */}
                </div>
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={(isReadOnly || isOnlyOne) && !reasonsForMissedConnections.includes('Reasons2')}
                    type="checkbox"
                    name="Reasons2"
                    checked={reasonsForMissedConnections.includes('Reasons2')}
                    onChange={this.handleReasonsForMissedConnection('form.reasonsForMissedConnection')}
                  />
                  <span>
                    <FormattedMessage {...messages.reasons2ForTravelDelay} />
                  </span>
                </div>
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={(isReadOnly || isOnlyOne) && !reasonsForMissedConnections.includes('Reasons3')}
                    type="checkbox"
                    name="Reasons3"
                    checked={reasonsForMissedConnections.includes('Reasons3')}
                    onChange={this.handleReasonsForMissedConnection('form.reasonsForMissedConnection')}
                  />
                  <span>
                    <FormattedMessage {...messages.reasons3ForTravelDelay} />
                  </span>
                </div>
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={(isReadOnly || isOnlyOne) && !reasonsForMissedConnections.includes('Reasons4')}
                    type="checkbox"
                    name="Reasons4"
                    checked={reasonsForMissedConnections.includes('Reasons4')}
                    onChange={this.handleReasonsForMissedConnection('form.reasonsForMissedConnection')}
                  />
                  <span>
                    <FormattedMessage {...messages.reasons4ForTravelDelay} />
                  </span>
                </div>
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.reasonsForMissedConnection}
                  />
                </ErrorMessage>
              </Validate>
            </div>
          </div>
          {isClaimGroupAllowed &&
            <div className={'ml-3 row'}>
              <div className={'col-sm-12'}>
                <HelpText>
                  The amount you claim below is PER MEMBER. It needs to be an EQUAL amount claimed, for each person you selected in the page “What Happened”.
                  If you want to claim DIFFERENT amounts for each person, please create a SEPARATE CLAIM per person.
                </HelpText>
              </div>
            </div>
          }
          <div className={'ml-3 mt-3'}>
            <PageSectionHeader>
              <FormattedMessage
                {...(isClaimGroupAllowed ? messages.lossInformationPerPerson : messages.lossInformation)}
              />
            </PageSectionHeader>
            {this.renderMissedConnectionInformationItems()}
          </div>
        </div>
      )
    );
  }

  // Missed Connection
  renderMissedConnectionVersion15() {
    const {
      missedConnection,
      flightNumberMissedConnection,
      flightDateMissedConnection,
      flightDetailsMissedConnection,
      didYourInitialFlightDelayCauseAMissedConnection,
      didYourMissedConnectionCauseYouToMissTheStartOfYourTourOrCruise,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted, isClaimGroupAllowed } = this.props;
    const isReadOnly = submitted || isSummary;
    const isFlightNumberValid = checkFlightNumberOnly(flightNumberMissedConnection);
    const isFlightDateValid = checkFlightDateOnly(flightDateMissedConnection);
    const flights = flightDetailsMissedConnection.flights || [];
    const flightDetail = flights.length === 1 ? flights[0] : flights[flightDetailsMissedConnection.selectedFlightIndex];
    const showSectionFlightDetails = flightDetailsMissedConnection.onSuccessFlighAPIRequest || flightDetailsMissedConnection.callFailFlighAPIRequest;
    const isDisable = isReadOnly || flightDetailsMissedConnection.onSuccessFlighAPIRequest || !flightDetailsMissedConnection.manuallyEnterFlight;
    return (
      missedConnection === 'true' && (
        <div className={'ml-3'}>
          <div className={'row'}>
            <div className={'col-sm-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.didYourInitialFlightDelayCauseAMissedConnection} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={didYourInitialFlightDelayCauseAMissedConnection === 'true'}
                    onChange={this.handleChange('form.didYourInitialFlightDelayCauseAMissedConnection')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={didYourInitialFlightDelayCauseAMissedConnection === 'false'}
                    onChange={this.handleChange('form.didYourInitialFlightDelayCauseAMissedConnection')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>
          {didYourInitialFlightDelayCauseAMissedConnection === 'true' &&
            <div className={'ml-4'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.pleaseEnterYourFlightNumberAndDateBelow} />
              </PageSectionHeader>
              <div className={'row'}>
                <div className={'col-sm-4 form-group'}>
                  <Validate
                    name="flightNumber"
                    validators={[checkFlightNumberOnly, required]}
                    group={this.validatorGroup}
                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                    validationCounter={this.state.validationCounter}
                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                    defaultValue={flightNumberMissedConnection}
                    fieldName={messages.flightNumber}
                  >
                    <Textbox
                      name="flightNumber"
                      type="text"
                      onChange={this.handleChange('form.flightNumberMissedConnection')}
                      value={flightNumberMissedConnection}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.flightNumber}
                      />
                    </ErrorMessage>
                    <ErrorMessage for="checkFlightNumberOnly">
                      <FormattedMessage
                        {...messages.checkFlightNumber}
                        values={messages.flightNumber}
                      />
                    </ErrorMessage>
                  </Validate>
                </div>
                <div className={'col-sm-4 form-group'}>
                  <Validate
                    name="flightDate"
                    validators={[checkFlightDateOnly, required]}
                    group={this.validatorGroup}
                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                    validationCounter={this.state.validationCounter}
                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                    defaultValue={flightDateMissedConnection}
                    fieldName={messages.flightDate}
                  >
                    <FlightDatePicker
                      position={'bottom-start'}
                      disabled={isReadOnly}
                      name="flightDate"
                      type="text"
                      onDayChange={this.handleDayChange('form.flightDateMissedConnection')}
                      value={flightDateMissedConnection}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.flightDate}
                      />
                    </ErrorMessage>
                    <ErrorMessage for="checkFlightDateOnly">
                      <FormattedMessage
                        {...messages.checkFlightDate}
                        values={messages.flightDate}
                      />
                    </ErrorMessage>
                  </Validate>
                </div>
                <div className={'col-sm-4 form-group'}></div>
              </div>
              <div className={'row'}>
                <div className={'col-sm-12 form-group'}>
                  <AsyncButton
                    id="searchFlightButton"
                    className={'btn-authentication'}
                    disabled={isReadOnly || (!isFlightNumberValid && !isFlightDateValid)}
                    loading={this.props.loading}
                    spinner={this.showSpinnerForElement('searchFlightButton')}
                    onClick={this.flightVerificationMissedConnection('flightDetailsMissedConnection')}
                  >
                    Search Flight
                  </AsyncButton>
                </div>
              </div>
              {flightDetailsMissedConnection.onPendingFlighAPIRequest && (
                <div className={'ml-2 row'}>
                  <div style={{ fontWeight: 'bold' }}>
                    <FormattedMessage {...messages.pendingFlightApiRequest} />
                  </div>
                </div>
              )}
              {flightDetailsMissedConnection.callFailFlighAPIRequest && flightDetailsMissedConnection && flightDetailsMissedConnection.error && (
                <div className={'row'}>
                  <div className={'col-sm-12'} style={{ color: 'red' }}>
                    {flightDetailsMissedConnection.error}
                  </div>
                </div>
              )}
              {flightDetailsMissedConnection.callFailFlighAPIRequest && flightDetail && (
                <div className={'row'}>
                  <div className={'form-group col-md-6'}>
                    <OptionsContainer>
                      <input
                        disabled={isReadOnly}
                        type="checkbox"
                        name="signature"
                        checked={flightDetailsMissedConnection.manuallyEnterFlight === true}
                        onChange={this.handleChange('form.flightDetailsMissedConnection.manuallyEnterFlight')}
                      />
                      <span>
                        <FormattedMessage {...messages.manuallyEnterFlight} />
                      </span>
                    </OptionsContainer>
                  </div>
                  <div className={'form-group col-md-6'}>
                  </div>
                </div>
              )}
              {(flightDetailsMissedConnection.onSuccessFlighAPIRequest && flights.length > 1) && (
                <div className="row">
                  <div className="col-sm-12">
                    <PageSectionHeader>
                      <FormattedMessage {...messages.pleaseSelectYourFlightBelow} />
                    </PageSectionHeader>
                    <div className="table-responsive">
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th />
                            <th><FormattedMessage {...messages.originAirport} /></th>
                            <th><FormattedMessage {...messages.destinationAirport} /></th>
                            <th><FormattedMessage {...messages.scheduledDeparture} /></th>
                          </tr>
                        </thead>
                        <tbody>
                          {flights.map((flight, index) => (
                            <tr key={index}>
                              <td>
                                <input
                                  type="radio"
                                  name="selectedFlight"
                                  value={index}
                                  checked={flightDetailsMissedConnection.selectedFlightIndex === index}
                                  onChange={() => this.handleFlightSelection('form.flightDetailsMissedConnection.selectedFlightIndex', index)}
                                  disabled={isReadOnly}
                                />
                              </td>
                              <td>{flight.originAirport}</td>
                              <td>{flight.destinationAirport}</td>
                              <td>{flight.flightDate}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              )}
              {(showSectionFlightDetails && flightDetail) && (
                <div className={'row'}>
                  <div className={'col-sm-12'}>
                    <Section>
                      <ControlContainer>
                        <div className={'row'}>
                          <div className={'col-sm-2'}>
                          </div>
                          <div className={'col-sm-3'}>
                            <h4>
                              <FormattedMessage {...messages.flightDetails} />
                            </h4>
                          </div>
                          <div className={'col-sm-7'}>
                            <strong>
                              <FormattedMessage {...messages.searchSuccess} />:
                            </strong>{' '}
                            {flightDetailsMissedConnection.success ? 'Yes' : 'No'}
                          </div>
                        </div>
                        <div className={'row'}>
                          <div className={'col-sm-6 form-group'}>
                            <PageSectionHeader>
                              <FormattedMessage {...messages.flightNumber} />
                            </PageSectionHeader>
                            <Textbox
                              name="flightNumber"
                              type="text"
                              onChange={this.handleChangeFlightDetail('flightDetailsMissedConnection', 'flightNumber')}
                              value={flightDetail.flightNumber}
                              disabled={isDisable}
                            />
                          </div>
                          <div className={'col-sm-6 form-group'}>
                            <PageSectionHeader>
                              <FormattedMessage {...messages.flightDate} />
                            </PageSectionHeader>
                            <DatePicker
                              name="flightDate"
                              type="text"
                              onDayChange={this.handleChangeFlightDetail('flightDetailsMissedConnection', 'flightDate')}
                              value={flightDetail.flightDate}
                              disabled={isDisable}
                            />
                          </div>
                        </div>
                        <div className={'row'}>
                          <div className={'col-sm-12 form-group'}>
                            <PageSectionHeader>
                              <FormattedMessage {...messages.airline} />
                            </PageSectionHeader>
                            <Textbox
                              name="airline"
                              type="text"
                              onChange={this.handleChangeFlightDetail('flightDetailsMissedConnection', 'airline')}
                              value={flightDetail.airline}
                              disabled={isDisable}
                            />
                          </div>
                        </div>
                        <div className={'row'}>
                          <div className={'col-sm-6 form-group'}>
                            <PageSectionHeader>
                              <FormattedMessage {...messages.originAirport} />
                            </PageSectionHeader>
                            <Textbox
                              name="originAirport"
                              type="text"
                              onChange={this.handleChangeFlightDetail('flightDetailsMissedConnection', 'originAirport')}
                              value={flightDetail.originAirport}
                              disabled={isDisable}
                            />
                          </div>
                          <div className={'col-sm-6 form-group'}>
                            <PageSectionHeader>
                              <FormattedMessage {...messages.destinationAirport} />
                            </PageSectionHeader>
                            <Textbox
                              name="destinationAirport"
                              type="text"
                              onChange={this.handleChangeFlightDetail('flightDetailsMissedConnection', 'destinationAirport')}
                              value={flightDetail.destinationAirport}
                              disabled={isDisable}
                            />
                          </div>
                        </div>
                        {!isDisable && (
                          <div className={'row'}>
                            <div className={'col-sm-6 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.scheduledOut} />
                              </PageSectionHeader>
                              <DatePicker
                                name="scheduledOut"
                                type="text"
                                onDayChange={this.handleChangeFlightDetail('flightDetailsMissedConnection', 'scheduledOut')}
                                value={flightDetail.scheduledOut}
                                disabled={isDisable}
                              />
                            </div>
                            <div className={'col-sm-6 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.scheduledIn} />
                              </PageSectionHeader>
                              <DatePicker
                                name="scheduledIn"
                                type="text"
                                onDayChange={this.handleChangeFlightDetail('flightDetailsMissedConnection', 'scheduledIn')}
                                value={flightDetail.scheduledIn}
                                disabled={isDisable}
                              />
                            </div>
                          </div>
                        )}
                        {isDisable && (
                          <div className={'row'}>
                            <div className={'col-sm-6 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.scheduledOut} />
                              </PageSectionHeader>
                              <Textbox
                                name="scheduledOut"
                                type="text"
                                onDayChange={this.handleChangeFlightDetail('flightDetailsMissedConnection', 'scheduledOut')}
                                value={flightDetail.scheduledOut}
                                disabled={isDisable}
                              />
                            </div>
                            <div className={'col-sm-6 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.scheduledIn} />
                              </PageSectionHeader>
                              <Textbox
                                name="scheduledIn"
                                type="text"
                                onDayChange={this.handleChangeFlightDetail('flightDetailsMissedConnection', 'scheduledIn')}
                                value={flightDetail.scheduledIn}
                                disabled={isDisable}
                              />
                            </div>
                          </div>
                        )}
                        <div className={'row'}>
                          <div className={'col-sm-3 form-group'}>
                            <PageSectionHeader>
                              <FormattedMessage {...messages.departureDelay} />
                            </PageSectionHeader>
                            <Textbox
                              name="departureDelay"
                              type="number"
                              onChange={this.handleChangeFlightDetail('flightDetailsMissedConnection', 'departureDelay')}
                              value={flightDetail.departureDelay}
                              disabled={isDisable}
                            />
                          </div>
                          <div className={'col-sm-3 form-group'}>
                            <PageSectionHeader>
                              <FormattedMessage {...messages.arrivalDelay} />
                            </PageSectionHeader>
                            <Textbox
                              name="arrivalDelay"
                              type="number"
                              onChange={this.handleChangeFlightDetail('flightDetailsMissedConnection', 'arrivalDelay')}
                              value={flightDetail.arrivalDelay}
                              disabled={isDisable}
                            />
                          </div>
                          <div className={'col-sm-6 form-group'}>
                            <PageSectionHeader>
                              <FormattedMessage {...messages.cancelled} />
                            </PageSectionHeader>
                            <select
                              name="cancelled"
                              className="form-control"
                              onChange={this.handleChangeFlightDetail('flightDetailsMissedConnection', 'cancelled')}
                              value={flightDetail.cancelled || ''}
                              disabled={isDisable}
                            >
                              <option value="">Select status</option>
                              <option value="Yes">Yes</option>
                              <option value="No">No</option>
                            </select>
                          </div>
                        </div>
                      </ControlContainer>
                    </Section>
                  </div>
                </div>
              )}
            </div>
          }
          <div className={'row'}>
            <div className={'col-sm-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.didYourMissedConnectionCauseYouToMissTheStartOfYourTourOrCruise} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={didYourMissedConnectionCauseYouToMissTheStartOfYourTourOrCruise === 'true'}
                    onChange={this.handleChange('form.didYourMissedConnectionCauseYouToMissTheStartOfYourTourOrCruise')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={didYourMissedConnectionCauseYouToMissTheStartOfYourTourOrCruise === 'false'}
                    onChange={this.handleChange('form.didYourMissedConnectionCauseYouToMissTheStartOfYourTourOrCruise')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>
          {isClaimGroupAllowed &&
            <div className={'row'}>
              <div className={'col-sm-12'}>
                <HelpText>
                  The amount you claim below is PER MEMBER. It needs to be an EQUAL amount claimed, for each person you selected in the page “What Happened”.
                  If you want to claim DIFFERENT amounts for each person, please create a SEPARATE CLAIM per person.
                </HelpText>
              </div>
            </div>
          }
          <div className={'mt-3'}>
            <PageSectionHeader>
              <FormattedMessage
                {...(isClaimGroupAllowed ? messages.lossInformationPerPerson : messages.lossInformation)}
              />
            </PageSectionHeader>
            {this.renderMissedConnectionInformationItems()}
          </div>
        </div>
      )
    );
  }

  renderMissedConnectionInformationItems() {
    const { missedConnectionInformationItems } = this.props.form;
    const newMissedConnectionInformationItems = this.appendIds(missedConnectionInformationItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newMissedConnectionInformationItems}
          onChange={this.onMissedConnectionInformationItemsChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  render() {
    const {
      tripCancellation,
      tripCancellationForAnyReason,
      travelInterruption,
      travelDelay,
      missedConnection,
    } = isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted, loading, jsonVersion } = this.props;
    const isRenderTravelCancellation = !!stepChangesToYourJourneyTrawickLookup.tripCancellation.claimCode;
    const isRenderTripCancellationForAnyReason = false;
    const isRenderTravelInterruption = !!stepChangesToYourJourneyTrawickLookup.travelInterruption.claimCode;
    const isRenderTravelDelay = !!stepChangesToYourJourneyTrawickLookup.travelDelay.claimCode;
    const isRenderMissedConnection = !!stepChangesToYourJourneyTrawickLookup.missedConnection.claimCode;
    const isReadOnly = submitted || isSummary;
    const isVersion15AndAbove = jsonVersion >= 15;
    return (
      <div className="app-content">
        {isRenderTravelCancellation &&
          <div className={'row'}>
            <div className={'col-sm-6 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.tripCancellation} /> <FNOLTooltip place={'bottom'} dataFor={'tripCancellationHint'} content={messages.tripCancellationTooltip.defaultMessage} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={tripCancellation === 'true'}
                    onChange={this.handleChange('form.tripCancellation')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={tripCancellation === 'false'}
                    onChange={this.handleChange('form.tripCancellation')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>}
        {(isRenderTravelCancellation && !isVersion15AndAbove) && this.renderTripCancellation()}
        {(isRenderTravelCancellation && isVersion15AndAbove) && (
          <TripCancellationVersion15AndAbove
            form={this.props.form}
            onFormDataChange={this.props.onFormDataChange}
            onInsuredTravelCancellation={this.onInsuredTravelCancellation}
            onSupplierTravelCancellation={this.onSupplierTravelCancellation}
            isSummary={isSummary}
            submitted={submitted}
            isReadOnly={isReadOnly}
            validatorGroup={this.validatorGroup}
            validationCounter={this.state.validationCounter}
            insuredsList={this.props.insuredsList}
            resetFormFields={this.props.resetFormFields}
            isClaimForFieldEnabled={this.props.isClaimForFieldEnabled}
            onTravelCancellationItemsChange={this.onTravelCancellationItemsChange}
            appendIds={this.appendIds}
            getFlightStatus={this.props.getFlightStatus}
            stepName={this.props.stepName}
            sendPhysicianEmail={this.props.sendPhysicianEmail}
          />
        )}
        {isRenderTripCancellationForAnyReason &&
          <div className={'row'}>
            <div className={'col-sm-6 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.tripCancellationForAnyReason} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={tripCancellationForAnyReason === 'true'}
                    onChange={this.handleChange('form.tripCancellationForAnyReason')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={tripCancellationForAnyReason === 'false'}
                    onChange={this.handleChange('form.tripCancellationForAnyReason')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>}
        {isRenderTripCancellationForAnyReason && this.renderTripCancellationForAnyReason()}
        {isRenderTravelInterruption &&
          <div className={'row'}>
            <div className={'col-sm-6 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.travelInterruption} /> <FNOLTooltip place={'bottom'} dataFor={'tripCancellationHint'} content={messages.travelInterruptionTooltip.defaultMessage} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={travelInterruption === 'true'}
                    onChange={this.handleChange('form.travelInterruption')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={travelInterruption === 'false'}
                    onChange={this.handleChange('form.travelInterruption')}
                    onClick={this.props.onResetFormTravelInterruption}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>}
        {(isRenderTravelInterruption && !isVersion15AndAbove) && this.renderTravelInterruption()}
        {(isRenderTravelInterruption && isVersion15AndAbove) && (
          <TripInterruptionVersion15AndAbove
            form={this.props.form}
            onFormDataChange={this.props.onFormDataChange}
            onInsuredTravelCancellation={this.onInsuredTravelCancellation}
            onSupplierTravelCancellation={this.onSupplierTravelCancellation}
            isSummary={isSummary}
            submitted={submitted}
            isReadOnly={isReadOnly}
            validatorGroup={this.validatorGroup}
            validationCounter={this.state.validationCounter}
            insuredsList={this.props.insuredsList}
            resetFormFields={this.props.resetFormFields}
            isClaimForFieldEnabled={this.props.isClaimForFieldEnabled}
            onTripInterruptionChange={this.onTripInterruptionChange}
            appendIds={this.appendIds}
            getFlightStatus={this.props.getFlightStatus}
            stepName={this.props.stepName}
            sendPhysicianEmailInterruption={this.props.sendPhysicianEmailInterruption}
          />
        )}
        {isRenderTravelDelay &&
          <div className={'row'}>
            <div className={'col-sm-6 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.travelDelay} /><FNOLTooltip place={'bottom'} dataFor={'travelDelayHint'} content={messages.travelDelayTooltip.defaultMessage} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={travelDelay === 'true'}
                    onChange={this.handleChange('form.travelDelay')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={travelDelay === 'false'}
                    onChange={this.handleChange('form.travelDelay')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>}
        {isRenderTravelDelay && this.renderTravelDelay()}
        {isRenderMissedConnection &&
          <div className={'row'}>
            <div className={'col-sm-6 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.missedConnection} /> <FNOLTooltip place={'bottom'} dataFor={'missedConnectionHint'} content={messages.missedConnectionTooltip.defaultMessage} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={missedConnection === 'true'}
                    onChange={this.handleChange('form.missedConnection')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={missedConnection === 'false'}
                    onChange={this.handleChange('form.missedConnection')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>}
        {(isRenderMissedConnection && !isVersion15AndAbove) && this.renderMissedConnection()}
        {(isRenderMissedConnection && isVersion15AndAbove) && this.renderMissedConnectionVersion15()}
        {!isSummary && (
          <div className={'row justify-content-between'}>
            <div className={'col-12 col-sm-auto'}>
              <div className={'row'}>
                <div className={'col-12 col-sm-auto'}>
                  <button
                    className="btn-outline"
                    onClick={this.props.prev}
                    onKeyDown={this.handleKeyDown}
                  >
                    Back
                  </button>
                </div>
                <div className={'col-12 col-sm-auto'}>
                  <Button
                    onClick={this.handleNext}
                    onKeyDown={this.handleKeyDown}
                    innerRef={(ref) => {
                      this.nextButton = ref;
                    }}
                  >
                    Next &gt;
                  </Button>
                </div>
              </div>
            </div>
            <div className={'col-12 col-sm-auto'}>
              {!submitted && (
                <AsyncButton
                  id={this.saveButtonId}
                  className="btn-outline"
                  loading={loading}
                  spinner={this.showSpinnerForElement(this.saveButtonId)}
                  onClick={this.handleSaveButtonClick}
                  onKeyDown={this.handleKeyDown}
                >
                  Save
                </AsyncButton>
              )}
            </div>
          </div>
        )}
        <ReactResizeDetector handleHeight onResize={this.onResize} />
      </div>
    );
  }
}

ChangesToYourJourneyStep.propTypes = {
  form: PropTypes.object,
  onFormDataChange: PropTypes.func,
  prev: PropTypes.func,
  next: PropTypes.func,
  onFormDataSave: PropTypes.func,
  loading: PropTypes.bool,
  isSummary: PropTypes.bool,
  submitted: PropTypes.bool,
  adjust: PropTypes.func,
  makeValid: PropTypes.func,
  makeError: PropTypes.func,
  onNext: PropTypes.func,
  step: PropTypes.number,
  currentStep: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isReadOnly: PropTypes.bool,
  errors: PropTypes.any,
  onResetFormTravelInterruption: PropTypes.func,
  sendPhysicianEmail: PropTypes.func,
  sendPhysicianEmailInterruption: PropTypes.func,
  validateStep: PropTypes.string,
  stepName: PropTypes.string,
  jsonVersion: PropTypes.string,
  isClaimGroupAllowed: PropTypes.bool,
  insuredsList: PropTypes.any,
  isClaimForFieldEnabled: PropTypes.bool,
  getFlightStatus: PropTypes.func,
  resetFormFields: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  form: makeSelectChangesToYourJourneyStep(),
  errors: makeSelectChangesToYourJourneyStepErrors(),
  currentStep: makeSelectCurrentStep(),
  loading: makeSelectProgressBarStatus(),
  jsonVersion: makeSelectJSONVersion(),
  isClaimGroupAllowed: makeSelectIsClaimGroupAllowed(),
  insuredsList: makeSelectInsuredsList(),
  isClaimForFieldEnabled: makeSelectIsClaimForFieldEnabled(),
});

const mapDispatchToProps = (dispatch) => ({
  onFormDataChange: (propertyName, value) => dispatch(handleFormDataChange(propertyName, value)),
  onFormDataSave: () => dispatch(saveFormData()),
  onNext: (errors) => dispatch(nextSlide(errors)),
  onResetFormTravelInterruption: () => dispatch(resetFormTravelInterruption()),
  onResetFormData: () => dispatch(resetFormData()),
  resetFormFields: (payload) => dispatch(resetFormFields(payload)),
  sendPhysicianEmail: () => dispatch(emailMedicalTravelDocument()),
  sendPhysicianEmailInterruption: () => dispatch(emailInterruptionDocument()),
  getFlightStatus: (flightNumber, flightDate, flightObjectName, currentStepName, claimCode) =>
    dispatch(getFlightStatusRequest(flightNumber, flightDate, flightObjectName, currentStepName, claimCode)),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);
const withReducer = injectReducer({ key: 'changesToYourJourneyStep', reducer });

export default compose(
  withReducer,
  withConnect
)(ChangesToYourJourneyStep);



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.ChangesToYourJourney/index.js